// Minecraft Resource Calculator - Phase 1: Essential Building Materials
// ~100 most commonly used blocks organized by category

const items = {
  natural: [
    { id: 'dirt', name: 'Dirt', stack: 64 },
    { id: 'grass-block', name: 'Grass Block', stack: 64 },
    { id: 'sand', name: 'Sand', stack: 64 },
    { id: 'gravel', name: 'Gravel', stack: 64 },
    { id: 'clay', name: 'Clay', stack: 64 },
    { id: 'mud', name: 'Mud', stack: 64 },
    { id: 'moss-block', name: 'Moss Block', stack: 64 },
    { id: 'podzol', name: 'Podzol', stack: 64 },
    { id: 'mycelium', name: 'Mycelium', stack: 64 },
    { id: 'ice', name: 'Ice', stack: 64 },
    { id: 'packed-ice', name: 'Packed Ice', stack: 64 },
    { id: 'blue-ice', name: 'Blue Ice', stack: 64 },
    { id: 'snow-block', name: 'Snow Block', stack: 64 },
    { id: 'obsidian', name: 'Obsidian', stack: 64 }
  ],

    nether: [
    { id: 'netherrack', name: 'Netherrack', stack: 64 },
    { id: 'soul-sand', name: 'Soul Sand', stack: 64 },
    { id: 'soul-soil', name: 'Soul Soil', stack: 64 },
    { id: 'magma-block', name: 'Magma Block', stack: 64 },
    { id: 'warped-wart-block', name: 'Warped Wart Block', stack: 64 },
    { id: 'nether-wart-block', name: 'Nether Wart Block', stack: 64 },
    { id: 'crying-obsidian', name: 'Crying Obsidian', stack: 64 },
    { id: 'respawn-anchor', name: 'Respawn Anchor', stack: 64 },
    { id: 'lodestone', name: 'Lodestone', stack: 64 }
  ],


  // === BUILDING BLOCKS ========================

stone: [
  // Cobblestone family
  { id: 'cobblestone', name: 'Cobblestone', stack: 64 },
  { id: 'cobblestone-stairs', name: 'Cobblestone Stairs', stack: 64 },
  { id: 'cobblestone-slab', name: 'Cobblestone Slab', stack: 64 },
  { id: 'mossy-cobblestone', name: 'Mossy Cobblestone', stack: 64 },
  { id: 'mossy-cobblestone-stairs', name: 'Mossy Cobblestone Stairs', stack: 64 },
  { id: 'mossy-cobblestone-slab', name: 'Mossy Cobblestone Slab', stack: 64 },
  
  // Stone family
  { id: 'stone', name: 'Stone', stack: 64 },
  { id: 'stone-stairs', name: 'Stone Stairs', stack: 64 },
  { id: 'stone-slab', name: 'Stone Slab', stack: 64 },
  { id: 'smooth-stone', name: 'Smooth Stone', stack: 64 },
  { id: 'smooth-stone-slab', name: 'Smooth Stone Slab', stack: 64 },
  
  // Stone Bricks family
  { id: 'stone-bricks', name: 'Stone Bricks', stack: 64 },
  { id: 'stone-brick-stairs', name: 'Stone Brick Stairs', stack: 64 },
  { id: 'stone-brick-slab', name: 'Stone Brick Slab', stack: 64 },
  { id: 'mossy-stone-bricks', name: 'Mossy Stone Bricks', stack: 64 },
  { id: 'mossy-stone-brick-stairs', name: 'Mossy Stone Brick Stairs', stack: 64 },
  { id: 'mossy-stone-brick-slab', name: 'Mossy Stone Brick Slab', stack: 64 },

  { id: 'chiseled-stone-bricks', name: 'Chiseled Stone Bricks', stack: 64 },
  
  
  { id: 'cracked-stone-bricks', name: 'Cracked Stone Bricks', stack: 64 },


  { id: 'infested-stone', name: 'Infested Stone', stack: 64 },
  { id: 'infested-cobblestone', name: 'Infested Cobblestone', stack: 64 },
  { id: 'infested-stone-bricks', name: 'Infested Stone Bricks', stack: 64 },
  { id: 'infested-mossy-stone-bricks', name: 'Infested Mossy Stone Bricks', stack: 64 },
  { id: 'infested-cracked-stone-bricks', name: 'Infested Cracked Stone Bricks', stack: 64 },
  { id: 'infested-chiseled-stone-bricks', name: 'Infested Chiseled Stone Bricks', stack: 64 },
  { id: 'infested-deepslate', name: 'Infested Deepslate', stack: 64 },
  
  // Granite family
  { id: 'granite', name: 'Granite', stack: 64 },
  { id: 'granite-stairs', name: 'Granite Stairs', stack: 64 },
  { id: 'granite-slab', name: 'Granite Slab', stack: 64 },
  { id: 'polished-granite', name: 'Polished Granite', stack: 64 },
  { id: 'polished-granite-stairs', name: 'Polished Granite Stairs', stack: 64 },
  { id: 'polished-granite-slab', name: 'Polished Granite Slab', stack: 64 },
  
  // Diorite family
  { id: 'diorite', name: 'Diorite', stack: 64 },
  { id: 'diorite-stairs', name: 'Diorite Stairs', stack: 64 },
  { id: 'diorite-slab', name: 'Diorite Slab', stack: 64 },
  { id: 'polished-diorite', name: 'Polished Diorite', stack: 64 },
  { id: 'polished-diorite-stairs', name: 'Polished Diorite Stairs', stack: 64 },
  { id: 'polished-diorite-slab', name: 'Polished Diorite Slab', stack: 64 },
  
  // Andesite family
  { id: 'andesite', name: 'Andesite', stack: 64 },
  { id: 'andesite-stairs', name: 'Andesite Stairs', stack: 64 },
  { id: 'andesite-slab', name: 'Andesite Slab', stack: 64 },
  { id: 'polished-andesite', name: 'Polished Andesite', stack: 64 },
  { id: 'polished-andesite-stairs', name: 'Polished Andesite Stairs', stack: 64 },
  { id: 'polished-andesite-slab', name: 'Polished Andesite Slab', stack: 64 },
  
  // Cobbled Deepslate family
  { id: 'cobbled-deepslate', name: 'Cobbled Deepslate', stack: 64 },
  { id: 'cobbled-deepslate-stairs', name: 'Cobbled Deepslate Stairs', stack: 64 },
  { id: 'cobbled-deepslate-slab', name: 'Cobbled Deepslate Slab', stack: 64 },
  
  // Polished Deepslate family
  { id: 'polished-deepslate', name: 'Polished Deepslate', stack: 64 },
  { id: 'polished-deepslate-stairs', name: 'Polished Deepslate Stairs', stack: 64 },
  { id: 'polished-deepslate-slab', name: 'Polished Deepslate Slab', stack: 64 },
  
  // Deepslate Bricks family
  { id: 'deepslate-bricks', name: 'Deepslate Bricks', stack: 64 },
  { id: 'deepslate-brick-stairs', name: 'Deepslate Brick Stairs', stack: 64 },
  { id: 'deepslate-brick-slab', name: 'Deepslate Brick Slab', stack: 64 },
  { id: 'cracked-deepslate-bricks', name: 'Cracked Deepslate Bricks', stack: 64 },
  { id: 'cracked-deepslate-tiles', name: 'Cracked Deepslate Tiles', stack: 64 },
  
  // Deepslate Tiles family
  { id: 'deepslate-tiles', name: 'Deepslate Tiles', stack: 64 },
  { id: 'deepslate-tile-stairs', name: 'Deepslate Tile Stairs', stack: 64 },
  { id: 'deepslate-tile-slab', name: 'Deepslate Tile Slab', stack: 64 },
  { id: 'chiseled-deepslate', name: 'Chiseled Deepslate', stack: 64 },
  
  // Tuff family
  { id: 'tuff', name: 'Tuff', stack: 64 },
  { id: 'tuff-stairs', name: 'Tuff Stairs', stack: 64 },
  { id: 'tuff-slab', name: 'Tuff Slab', stack: 64 },
  { id: 'chiseled-tuff', name: 'Chiseled Tuff', stack: 64 },
  
  // Polished Tuff family
  { id: 'polished-tuff', name: 'Polished Tuff', stack: 64 },
  { id: 'polished-tuff-stairs', name: 'Polished Tuff Stairs', stack: 64 },
  { id: 'polished-tuff-slab', name: 'Polished Tuff Slab', stack: 64 },
  
  // Tuff Bricks family
  { id: 'tuff-bricks', name: 'Tuff Bricks', stack: 64 },
  { id: 'tuff-brick-stairs', name: 'Tuff Brick Stairs', stack: 64 },
  { id: 'tuff-brick-slab', name: 'Tuff Brick Slab', stack: 64 },
  { id: 'chiseled-tuff-bricks', name: 'Chiseled Tuff Bricks', stack: 64 },
  
  // Calcite (standalone)
  { id: 'calcite', name: 'Calcite', stack: 64 }
],

decorative_stone: [
  { id: 'basalt', name: 'Basalt', stack: 64 },
  
  { id: 'blackstone', name: 'Blackstone', stack: 64 },
  { id: 'blackstone-stairs', name: 'Blackstone Stairs', stack: 64 },
  { id: 'blackstone-slab', name: 'Blackstone Slab', stack: 64 },
  { id: 'polished-blackstone', name: 'Polished Blackstone', stack: 64 },
  { id: 'polished-blackstone-stairs', name: 'Polished Blackstone Stairs', stack: 64 },
  { id: 'polished-blackstone-slab', name: 'Polished Blackstone Slab', stack: 64 },
  { id: 'polished-blackstone-bricks', name: 'Polished Blackstone Bricks', stack: 64 },
  { id: 'polished-blackstone-brick-stairs', name: 'Polished Blackstone Brick Stairs', stack: 64 },
  { id: 'polished-blackstone-brick-slab', name: 'Polished Blackstone Brick Slab', stack: 64 },
  
  { id: 'end-stone', name: 'End Stone', stack: 64 },
  { id: 'end-stone-bricks', name: 'End Stone Bricks', stack: 64 },
  { id: 'end-stone-brick-stairs', name: 'End Stone Brick Stairs', stack: 64 },
  { id: 'end-stone-brick-slab', name: 'End Stone Brick Slab', stack: 64 },
  
  { id: 'prismarine', name: 'Prismarine', stack: 64 },
  { id: 'prismarine-stairs', name: 'Prismarine Stairs', stack: 64 },
  { id: 'prismarine-slab', name: 'Prismarine Slab', stack: 64 },
  { id: 'prismarine-bricks', name: 'Prismarine Bricks', stack: 64 },
  { id: 'prismarine-brick-stairs', name: 'Prismarine Brick Stairs', stack: 64 },
  { id: 'prismarine-brick-slab', name: 'Prismarine Brick Slab', stack: 64 },
  { id: 'dark-prismarine', name: 'Dark Prismarine', stack: 64 },
  { id: 'dark-prismarine-stairs', name: 'Dark Prismarine Stairs', stack: 64 },
  { id: 'dark-prismarine-slab', name: 'Dark Prismarine Slab', stack: 64 },
  
  { id: 'nether-bricks', name: 'Nether Bricks', stack: 64 },
  { id: 'nether-brick-stairs', name: 'Nether Brick Stairs', stack: 64 },
  { id: 'nether-brick-slab', name: 'Nether Brick Slab', stack: 64 },
  { id: 'red-nether-bricks', name: 'Red Nether Bricks', stack: 64 },
  { id: 'red-nether-brick-stairs', name: 'Red Nether Brick Stairs', stack: 64 },
  { id: 'red-nether-brick-slab', name: 'Red Nether Brick Slab', stack: 64 },
  { id: 'chiseled-nether-bricks', name: 'Chiseled Nether Bricks', stack: 64 },
  
  { id: 'bricks', name: 'Bricks', stack: 64 },
  { id: 'brick-stairs', name: 'Brick Stairs', stack: 64 },
  { id: 'brick-slab', name: 'Brick Slab', stack: 64 },
  
  { id: 'mud-bricks', name: 'Mud Bricks', stack: 64 },
  { id: 'mud-brick-stairs', name: 'Mud Brick Stairs', stack: 64 },
  { id: 'mud-brick-slab', name: 'Mud Brick Slab', stack: 64 },
  
  { id: 'sandstone', name: 'Sandstone', stack: 64 },
  { id: 'sandstone-stairs', name: 'Sandstone Stairs', stack: 64 },
  { id: 'sandstone-slab', name: 'Sandstone Slab', stack: 64 },
  { id: 'smooth-sandstone', name: 'Smooth Sandstone', stack: 64 },
  { id: 'smooth-sandstone-stairs', name: 'Smooth Sandstone Stairs', stack: 64 },
  { id: 'smooth-sandstone-slab', name: 'Smooth Sandstone Slab', stack: 64 },
  
  { id: 'red-sand', name: 'Red Sand', stack: 64 },
  { id: 'red-sandstone', name: 'Red Sandstone', stack: 64 },
  { id: 'red-sandstone-stairs', name: 'Red Sandstone Stairs', stack: 64 },
  { id: 'red-sandstone-slab', name: 'Red Sandstone Slab', stack: 64 },
  { id: 'smooth-red-sandstone', name: 'Smooth Red Sandstone', stack: 64 },
  { id: 'smooth-red-sandstone-stairs', name: 'Smooth Red Sandstone Stairs', stack: 64 },
  { id: 'smooth-red-sandstone-slab', name: 'Smooth Red Sandstone Slab', stack: 64 },
  
  { id: 'purpur-block', name: 'Purpur Block', stack: 64 },
  { id: 'purpur-stairs', name: 'Purpur Stairs', stack: 64 },
  { id: 'purpur-slab', name: 'Purpur Slab', stack: 64 },
  { id: 'purpur-pillar', name: 'Purpur Pillar', stack: 64 },
  
  { id: 'block-of-quartz', name: 'Block of Quartz', stack: 64 },
  { id: 'quartz-stairs', name: 'Quartz Stairs', stack: 64 },
  { id: 'quartz-slab', name: 'Quartz Slab', stack: 64 },
  { id: 'quartz-bricks', name: 'Quartz Bricks', stack: 64 },
  { id: 'smooth-quartz-block', name: 'Smooth Quartz Block', stack: 64 },
  { id: 'smooth-quartz-stairs', name: 'Smooth Quartz Stairs', stack: 64 },
  { id: 'smooth-quartz-slab', name: 'Smooth Quartz Slab', stack: 64 },
  
  { id: 'resin-block', name: 'Resin Block', stack: 64 },
  { id: 'resin-bricks', name: 'Resin Bricks', stack: 64 },
  { id: 'resin-brick-stairs', name: 'Resin Brick Stairs', stack: 64 },
  { id: 'resin-brick-slab', name: 'Resin Brick Slab', stack: 64 },
  { id: 'chiseled-resin-bricks', name: 'Chiseled Resin Bricks', stack: 64 }
],

walls: [
  // Stone walls
  { id: 'cobblestone-wall', name: 'Cobblestone Wall', stack: 64 },
  { id: 'mossy-cobblestone-wall', name: 'Mossy Cobblestone Wall', stack: 64 },
  { id: 'stone-brick-wall', name: 'Stone Brick Wall', stack: 64 },
  { id: 'mossy-stone-brick-wall', name: 'Mossy Stone Brick Wall', stack: 64 },
  { id: 'tuff-wall', name: 'Tuff Wall', stack: 64 },
  { id: 'polished-tuff-wall', name: 'Polished Tuff Wall', stack: 64 },
  { id: 'tuff-brick-wall', name: 'Tuff Brick Wall', stack: 64 },
  { id: 'granite-wall', name: 'Granite Wall', stack: 64 },
  { id: 'diorite-wall', name: 'Diorite Wall', stack: 64 },
  { id: 'andesite-wall', name: 'Andesite Wall', stack: 64 },
  { id: 'deepslate-brick-wall', name: 'Deepslate Brick Wall', stack: 64 },
  { id: 'deepslate-tile-wall', name: 'Deepslate Tile Wall', stack: 64 },
  { id: 'polished-deepslate-wall', name: 'Polished Deepslate Wall', stack: 64 },
  { id: 'cobbled-deepslate-wall', name: 'Cobbled Deepslate Wall', stack: 64 },
  
  // Decorative walls
  { id: 'blackstone-wall', name: 'Blackstone Wall', stack: 64 },
  { id: 'polished-blackstone-wall', name: 'Polished Blackstone Wall', stack: 64 },
  { id: 'polished-blackstone-brick-wall', name: 'Polished Blackstone Brick Wall', stack: 64 },
  { id: 'end-stone-brick-wall', name: 'End Stone Brick Wall', stack: 64 },
  { id: 'prismarine-wall', name: 'Prismarine Wall', stack: 64 },
  { id: 'nether-brick-wall', name: 'Nether Brick Wall', stack: 64 },
  { id: 'red-nether-brick-wall', name: 'Red Nether Brick Wall', stack: 64 },
  { id: 'brick-wall', name: 'Brick Wall', stack: 64 },
  { id: 'mud-brick-wall', name: 'Mud Brick Wall', stack: 64 },
  { id: 'sandstone-wall', name: 'Sandstone Wall', stack: 64 },
  { id: 'red-sandstone-wall', name: 'Red Sandstone Wall', stack: 64 },
  { id: 'resin-brick-wall', name: 'Resin Brick Wall', stack: 64 }
],

  logs: [
    { id: 'oak-log', name: 'Oak Log', stack: 64 },
    { id: 'spruce-log', name: 'Spruce Log', stack: 64 },
    { id: 'birch-log', name: 'Birch Log', stack: 64 },
    { id: 'jungle-log', name: 'Jungle Log', stack: 64 },
    { id: 'acacia-log', name: 'Acacia Log', stack: 64 },
    { id: 'dark-oak-log', name: 'Dark Oak Log', stack: 64 },
    { id: 'mangrove-log', name: 'Mangrove Log', stack: 64 },
    { id: 'cherry-log', name: 'Cherry Log', stack: 64 },
    { id: 'crimson-stem', name: 'Crimson Stem', stack: 64},
    { id: 'warped-stem', name: 'Warped Stem', stack: 64 },
    { id: 'pale-oak-log', name: 'Pale Oak Log', stack: 64 },
    { id: 'stripped-oak-log', name: 'Stripped Oak Log', stack: 64 },
  { id: 'stripped-spruce-log', name: 'Stripped Spruce Log', stack: 64 },
  { id: 'stripped-birch-log', name: 'Stripped Birch Log', stack: 64 },
  { id: 'stripped-jungle-log', name: 'Stripped Jungle Log', stack: 64 },
  { id: 'stripped-acacia-log', name: 'Stripped Acacia Log', stack: 64 },
  { id: 'stripped-dark-oak-log', name: 'Stripped Dark Oak Log', stack: 64 },
  { id: 'stripped-mangrove-log', name: 'Stripped Mangrove Log', stack: 64 },
  { id: 'stripped-cherry-log', name: 'Stripped Cherry Log', stack: 64 },
  { id: 'stripped-pale-oak-log', name: 'Stripped Pale Oak Log', stack: 64 },
  { id: 'stripped-crimson-stem', name: 'Stripped Crimson Stem', stack: 64 },
  { id: 'stripped-warped-stem', name: 'Stripped Warped Stem', stack: 64 },
  { id: 'stripped-bamboo-block', name: 'Stripped Bamboo Block', stack: 64 },
  
  { id: 'stripped-oak-wood', name: 'Stripped Oak Wood', stack: 64 },
  { id: 'stripped-spruce-wood', name: 'Stripped Spruce Wood', stack: 64 },
  { id: 'stripped-birch-wood', name: 'Stripped Birch Wood', stack: 64 },
  { id: 'stripped-jungle-wood', name: 'Stripped Jungle Wood', stack: 64 },
  { id: 'stripped-acacia-wood', name: 'Stripped Acacia Wood', stack: 64 },
  { id: 'stripped-dark-oak-wood', name: 'Stripped Dark Oak Wood', stack: 64 },
  { id: 'stripped-mangrove-wood', name: 'Stripped Mangrove Wood', stack: 64 },
  { id: 'stripped-cherry-wood', name: 'Stripped Cherry Wood', stack: 64 },
  { id: 'stripped-pale-oak-wood', name: 'Stripped Pale Oak Wood', stack: 64 },
  { id: 'stripped-crimson-hyphae', name: 'Stripped Crimson Hyphae', stack: 64 },
  { id: 'stripped-warped-hyphae', name: 'Stripped Warped Hyphae', stack: 64 }

  ],

  planks: [
      // Oak family
        { id: 'oak-planks', name: 'Oak Planks', stack: 64 },
        { id: 'oak-stairs', name: 'Oak Stairs', stack: 64 },
        { id: 'oak-slab', name: 'Oak Slab', stack: 64 },
        { id: 'oak-shelf', name: 'Oak Shelf', stack: 64 },
        { id: 'spruce-planks', name: 'Spruce Planks', stack: 64 },
        { id: 'spruce-stairs', name: 'Spruce Stairs', stack: 64 },
        { id: 'spruce-slab', name: 'Spruce Slab', stack: 64 },
  { id: 'spruce-shelf', name: 'Spruce Shelf', stack: 64 },
        { id: 'birch-planks', name: 'Birch Planks', stack: 64 },
        { id: 'birch-stairs', name: 'Birch Stairs', stack: 64 },
        { id: 'birch-slab', name: 'Birch Slab', stack: 64 },
  { id: 'birch-shelf', name: 'Birch Shelf', stack: 64 },
        { id: 'jungle-planks', name: 'Jungle Planks', stack: 64 },
        { id: 'jungle-stairs', name: 'Jungle Stairs', stack: 64 },
        { id: 'jungle-slab', name: 'Jungle Slab', stack: 64 },
  { id: 'jungle-shelf', name: 'Jungle Shelf', stack: 64 },
        { id: 'acacia-planks', name: 'Acacia Planks', stack: 64 },
        { id: 'acacia-stairs', name: 'Acacia Stairs', stack: 64 },
        { id: 'acacia-slab', name: 'Acacia Slab', stack: 64 },
  { id: 'acacia-shelf', name: 'Acacia Shelf', stack: 64 },
        { id: 'dark-oak-planks', name: 'Dark Oak Planks', stack: 64 },
        { id: 'dark-oak-stairs', name: 'Dark Oak Stairs', stack: 64 },
        { id: 'dark-oak-slab', name: 'Dark Oak Slab', stack: 64 },
  { id: 'dark-oak-shelf', name: 'Dark Oak Shelf', stack: 64 },
        { id: 'mangrove-planks', name: 'Mangrove Planks', stack: 64 },
        { id: 'mangrove-stairs', name: 'Mangrove Stairs', stack: 64 },
        { id: 'mangrove-slab', name: 'Mangrove Slab', stack: 64 },
  { id: 'mangrove-shelf', name: 'Mangrove Shelf', stack: 64 },
        { id: 'cherry-planks', name: 'Cherry Planks', stack: 64 },
        { id: 'cherry-stairs', name: 'Cherry Stairs', stack: 64 },
        { id: 'cherry-slab', name: 'Cherry Slab', stack: 64 },
  { id: 'cherry-shelf', name: 'Cherry Shelf', stack: 64 },
        { id: 'bamboo-planks', name: 'Bamboo Planks', stack: 64 },
        { id: 'bamboo-stairs', name: 'Bamboo Stairs', stack: 64 },
        { id: 'bamboo-slab', name: 'Bamboo Slab', stack: 64 },
  { id: 'bamboo-shelf', name: 'Bamboo Shelf', stack: 64 },
        { id: 'crimson-planks', name: 'Crimson Planks', stack: 64 },
        { id: 'crimson-stairs', name: 'Crimson Stairs', stack: 64 },
        { id: 'crimson-slab', name: 'Crimson Slab', stack: 64 },
  { id: 'crimson-shelf', name: 'Crimson Shelf', stack: 64 },
        { id: 'warped-planks', name: 'Warped Planks', stack: 64 },
        { id: 'warped-stairs', name: 'Warped Stairs', stack: 64 },
        { id: 'warped-slab', name: 'Warped Slab', stack: 64 },
  { id: 'warped-shelf', name: 'Warped Shelf', stack: 64 },
        { id: 'pale-oak-planks', name: 'Pale Oak Planks', stack: 64 },
        { id: 'pale-oak-stairs', name: 'Pale Oak Stairs', stack: 64 },
        { id: 'pale-oak-slab', name: 'Pale Oak Slab', stack: 64 },
        { id: 'pale-oak-shelf', name: 'Pale Oak shelf', stack: 64 }
      ],

   leaves: [
  { id: 'oak-leaves', name: 'Oak Leaves', stack: 64 },
  { id: 'spruce-leaves', name: 'Spruce Leaves', stack: 64 },
  { id: 'birch-leaves', name: 'Birch Leaves', stack: 64 },
  { id: 'jungle-leaves', name: 'Jungle Leaves', stack: 64 },
  { id: 'acacia-leaves', name: 'Acacia Leaves', stack: 64 },
  { id: 'dark-oak-leaves', name: 'Dark Oak Leaves', stack: 64 },
  { id: 'mangrove-leaves', name: 'Mangrove Leaves', stack: 64 },
  { id: 'cherry-leaves', name: 'Cherry Leaves', stack: 64 },
  { id: 'pale-oak-leaves', name: 'Pale Oak Leaves', stack: 64 },
  { id: 'azalea-leaves', name: 'Azalea Leaves', stack: 64 },
  { id: 'flowering-azalea-leaves', name: 'Flowering Azalea Leaves', stack: 64 },
  { id: 'nether-wart-block', name: 'Nether Wart Block', stack: 64 },
  { id: 'warped-wart-block', name: 'Warped Wart Block', stack: 64 }
]  , 

fences_gates: [
  { id: 'oak-fence', name: 'Oak Fence', stack: 64 },
  { id: 'spruce-fence', name: 'Spruce Fence', stack: 64 },
  { id: 'birch-fence', name: 'Birch Fence', stack: 64 },
  { id: 'jungle-fence', name: 'Jungle Fence', stack: 64 },
  { id: 'acacia-fence', name: 'Acacia Fence', stack: 64 },
  { id: 'dark-oak-fence', name: 'Dark Oak Fence', stack: 64 },
  { id: 'mangrove-fence', name: 'Mangrove Fence', stack: 64 },
  { id: 'cherry-fence', name: 'Cherry Fence', stack: 64 },
  { id: 'bamboo-fence', name: 'Bamboo Fence', stack: 64 },
  { id: 'crimson-fence', name: 'Crimson Fence', stack: 64 },
  { id: 'warped-fence', name: 'Warped Fence', stack: 64 },
  { id: 'pale-oak-fence', name: 'Pale Oak Fence', stack: 64 },
  { id: 'nether-brick-fence', name: 'Nether Brick Fence', stack: 64 },
  { id: 'oak-fence-gate', name: 'Oak Fence Gate', stack: 64 },
  { id: 'spruce-fence-gate', name: 'Spruce Fence Gate', stack: 64 },
  { id: 'birch-fence-gate', name: 'Birch Fence Gate', stack: 64 },
  { id: 'jungle-fence-gate', name: 'Jungle Fence Gate', stack: 64 },
  { id: 'acacia-fence-gate', name: 'Acacia Fence Gate', stack: 64 },
  { id: 'dark-oak-fence-gate', name: 'Dark Oak Fence Gate', stack: 64 },
  { id: 'mangrove-fence-gate', name: 'Mangrove Fence Gate', stack: 64 },
  { id: 'cherry-fence-gate', name: 'Cherry Fence Gate', stack: 64 },
  { id: 'bamboo-fence-gate', name: 'Bamboo Fence Gate', stack: 64 },
  { id: 'crimson-fence-gate', name: 'Crimson Fence Gate', stack: 64 },
  { id: 'warped-fence-gate', name: 'Warped Fence Gate', stack: 64 },
  { id: 'pale-oak-fence-gate', name: 'Pale Oak Fence Gate', stack: 64 }
],

doors_trapdoors: [
  { id: 'oak-door', name: 'Oak Door', stack: 64 },
  { id: 'spruce-door', name: 'Spruce Door', stack: 64 },
  { id: 'birch-door', name: 'Birch Door', stack: 64 },
  { id: 'jungle-door', name: 'Jungle Door', stack: 64 },
  { id: 'acacia-door', name: 'Acacia Door', stack: 64 },
  { id: 'dark-oak-door', name: 'Dark Oak Door', stack: 64 },
  { id: 'mangrove-door', name: 'Mangrove Door', stack: 64 },
  { id: 'cherry-door', name: 'Cherry Door', stack: 64 },
  { id: 'bamboo-door', name: 'Bamboo Door', stack: 64 },
  { id: 'crimson-door', name: 'Crimson Door', stack: 64 },
  { id: 'warped-door', name: 'Warped Door', stack: 64 },
  { id: 'pale-oak-door', name: 'Pale Oak Door', stack: 64 },
  { id: 'iron-door', name: 'Iron Door', stack: 64 },
  { id: 'oak-trapdoor', name: 'Oak Trapdoor', stack: 64 },
  { id: 'spruce-trapdoor', name: 'Spruce Trapdoor', stack: 64 },
  { id: 'birch-trapdoor', name: 'Birch Trapdoor', stack: 64 },
  { id: 'jungle-trapdoor', name: 'Jungle Trapdoor', stack: 64 },
  { id: 'acacia-trapdoor', name: 'Acacia Trapdoor', stack: 64 },
  { id: 'dark-oak-trapdoor', name: 'Dark Oak Trapdoor', stack: 64 },
  { id: 'mangrove-trapdoor', name: 'Mangrove Trapdoor', stack: 64 },
  { id: 'cherry-trapdoor', name: 'Cherry Trapdoor', stack: 64 },
  { id: 'bamboo-trapdoor', name: 'Bamboo Trapdoor', stack: 64 },
  { id: 'crimson-trapdoor', name: 'Crimson Trapdoor', stack: 64 },
  { id: 'warped-trapdoor', name: 'Warped Trapdoor', stack: 64 },
  { id: 'pale-oak-trapdoor', name: 'Pale Oak Trapdoor', stack: 64 },
  { id: 'iron-trapdoor', name: 'Iron Trapdoor', stack: 64 }
],

signs_frames: [
  { id: 'oak-sign', name: 'Oak Sign', stack: 16 },
  { id: 'spruce-sign', name: 'Spruce Sign', stack: 16 },
  { id: 'birch-sign', name: 'Birch Sign', stack: 16 },
  { id: 'jungle-sign', name: 'Jungle Sign', stack: 16 },
  { id: 'acacia-sign', name: 'Acacia Sign', stack: 16 },
  { id: 'dark-oak-sign', name: 'Dark Oak Sign', stack: 16 },
  { id: 'mangrove-sign', name: 'Mangrove Sign', stack: 16 },
  { id: 'cherry-sign', name: 'Cherry Sign', stack: 16 },
  { id: 'bamboo-sign', name: 'Bamboo Sign', stack: 16 },
  { id: 'crimson-sign', name: 'Crimson Sign', stack: 16 },
  { id: 'warped-sign', name: 'Warped Sign', stack: 16 },
  { id: 'pale-oak-sign', name: 'Pale Oak Sign', stack: 16 },
  { id: 'oak-hanging-sign', name: 'Oak Hanging Sign', stack: 16 },
  { id: 'spruce-hanging-sign', name: 'Spruce Hanging Sign', stack: 16 },
  { id: 'birch-hanging-sign', name: 'Birch Hanging Sign', stack: 16 },
  { id: 'jungle-hanging-sign', name: 'Jungle Hanging Sign', stack: 16 },
  { id: 'acacia-hanging-sign', name: 'Acacia Hanging Sign', stack: 16 },
  { id: 'dark-oak-hanging-sign', name: 'Dark Oak Hanging Sign', stack: 16 },
  { id: 'mangrove-hanging-sign', name: 'Mangrove Hanging Sign', stack: 16 },
  { id: 'cherry-hanging-sign', name: 'Cherry Hanging Sign', stack: 16 },
  { id: 'bamboo-hanging-sign', name: 'Bamboo Hanging Sign', stack: 16 },
  { id: 'crimson-hanging-sign', name: 'Crimson Hanging Sign', stack: 16 },
  { id: 'warped-hanging-sign', name: 'Warped Hanging Sign', stack: 16 },
  { id: 'pale-oak-hanging-sign', name: 'Pale Oak Hanging Sign', stack: 16 }
],

copper: [
      { id: 'copper-block', name: 'Copper Block', stack: 64 },
      { id: 'exposed-copper', name: 'Exposed Copper', stack: 64 },
      { id: 'weathered-copper', name: 'Weathered Copper', stack: 64 },
      { id: 'oxidized-copper', name: 'Oxidized Copper', stack: 64 },
      { id: 'cut-copper', name: 'Cut Copper', stack: 64 },
      { id: 'exposed-cut-copper', name: 'Exposed Cut Copper', stack: 64 },
      { id: 'weathered-cut-copper', name: 'Weathered Cut Copper', stack: 64 },
      { id: 'oxidized-cut-copper', name: 'Oxidized Cut Copper', stack: 64 },
      
      // Cut Copper Slabs
      { id: 'cut-copper-slab', name: 'Cut Copper Slab', stack: 64 },
      { id: 'exposed-cut-copper-slab', name: 'Exposed Cut Copper Slab', stack: 64 },
      { id: 'weathered-cut-copper-slab', name: 'Weathered Cut Copper Slab', stack: 64 },
      { id: 'oxidized-cut-copper-slab', name: 'Oxidized Cut Copper Slab', stack: 64 },
      
      // Cut Copper Stairs
      { id: 'cut-copper-stairs', name: 'Cut Copper Stairs', stack: 64 },
      { id: 'exposed-cut-copper-stairs', name: 'Exposed Cut Copper Stairs', stack: 64 },
      { id: 'weathered-cut-copper-stairs', name: 'Weathered Cut Copper Stairs', stack: 64 },
      { id: 'oxidized-cut-copper-stairs', name: 'Oxidized Cut Copper Stairs', stack: 64 },

      // Waxed Variants (Blocks)
      { id: 'waxed-copper-block', name: 'Waxed Copper Block', stack: 64 },
      { id: 'waxed-exposed-copper', name: 'Waxed Exposed Copper', stack: 64 },
      { id: 'waxed-weathered-copper', name: 'Waxed Weathered Copper', stack: 64 },
      { id: 'waxed-oxidized-copper', name: 'Waxed Oxidized Copper', stack: 64 },
      { id: 'waxed-cut-copper', name: 'Waxed Cut Copper', stack: 64 },
      { id: 'waxed-exposed-cut-copper', name: 'Waxed Exposed Cut Copper', stack: 64 },
      { id: 'waxed-weathered-cut-copper', name: 'Waxed Weathered Cut Copper', stack: 64 },
      { id: 'waxed-oxidized-cut-copper', name: 'Waxed Oxidized Cut Copper', stack: 64 },

      // Waxed Cut Copper Slabs (Added)
      { id: 'waxed-cut-copper-slab', name: 'Waxed Cut Copper Slab', stack: 64 },
      { id: 'waxed-exposed-cut-copper-slab', name: 'Waxed Exposed Cut Copper Slab', stack: 64 },
      { id: 'waxed-weathered-cut-copper-slab', name: 'Waxed Weathered Cut Copper Slab', stack: 64 },
      { id: 'waxed-oxidized-cut-copper-slab', name: 'Waxed Oxidized Cut Copper Slab', stack: 64 },

      // Waxed Cut Copper Stairs (Added)
      { id: 'waxed-cut-copper-stairs', name: 'Waxed Cut Copper Stairs', stack: 64 },
      { id: 'waxed-exposed-cut-copper-stairs', name: 'Waxed Exposed Cut Copper Stairs', stack: 64 },
      { id: 'waxed-weathered-cut-copper-stairs', name: 'Waxed Weathered Cut Copper Stairs', stack: 64 },
      { id: 'waxed-oxidized-cut-copper-stairs', name: 'Waxed Oxidized Cut Copper Stairs', stack: 64 },

      // Copper Grates (1.21 Update)
      { id: 'copper-grate', name: 'Copper Grate', stack: 64 },
      { id: 'exposed-copper-grate', name: 'Exposed Copper Grate', stack: 64 },
      { id: 'weathered-copper-grate', name: 'Weathered Copper Grate', stack: 64 },
      { id: 'oxidized-copper-grate', name: 'Oxidized Copper Grate', stack: 64 },
      { id: 'waxed-copper-grate', name: 'Waxed Copper Grate', stack: 64 },
      { id: 'waxed-exposed-copper-grate', name: 'Waxed Exposed Copper Grate', stack: 64 },
      { id: 'waxed-weathered-copper-grate', name: 'Waxed Weathered Copper Grate', stack: 64 },
      { id: 'waxed-oxidized-copper-grate', name: 'Waxed Oxidized Copper Grate', stack: 64 },

      // Copper Bulbs (1.21 Update)
      { id: 'copper-bulb', name: 'Copper Bulb', stack: 64 },
      { id: 'exposed-copper-bulb', name: 'Exposed Copper Bulb', stack: 64 },
      { id: 'weathered-copper-bulb', name: 'Weathered Copper Bulb', stack: 64 },
      { id: 'oxidized-copper-bulb', name: 'Oxidized Copper Bulb', stack: 64 },
      { id: 'waxed-copper-bulb', name: 'Waxed Copper Bulb', stack: 64 },
      { id: 'waxed-exposed-copper-bulb', name: 'Waxed Exposed Copper Bulb', stack: 64 },
      { id: 'waxed-weathered-copper-bulb', name: 'Waxed Weathered Copper Bulb', stack: 64 },
      { id: 'waxed-oxidized-copper-bulb', name: 'Waxed Oxidized Copper Bulb', stack: 64 },

      // Copper Doors & Trapdoors (1.21 Update)
      { id: 'copper-door', name: 'Copper Door', stack: 64 },
      { id: 'exposed-copper-door', name: 'Exposed Copper Door', stack: 64 },
      { id: 'weathered-copper-door', name: 'Weathered Copper Door', stack: 64 },
      { id: 'oxidized-copper-door', name: 'Oxidized Copper Door', stack: 64 },
      { id: 'copper-trapdoor', name: 'Copper Trapdoor', stack: 64 },
      { id: 'exposed-copper-trapdoor', name: 'Exposed Copper Trapdoor', stack: 64 },
      { id: 'weathered-copper-trapdoor', name: 'Weathered Copper Trapdoor', stack: 64 },
      { id: 'oxidized-copper-trapdoor', name: 'Oxidized Copper Trapdoor', stack: 64 },
      
      // Waxed Doors & Trapdoors
      { id: 'waxed-copper-door', name: 'Waxed Copper Door', stack: 64 },
      { id: 'waxed-exposed-copper-door', name: 'Waxed Exposed Copper Door', stack: 64 },
      { id: 'waxed-weathered-copper-door', name: 'Waxed Weathered Copper Door', stack: 64 },
      { id: 'waxed-oxidized-copper-door', name: 'Waxed Oxidized Copper Door', stack: 64 },
      { id: 'waxed-copper-trapdoor', name: 'Waxed Copper Trapdoor', stack: 64 },
      { id: 'waxed-exposed-copper-trapdoor', name: 'Waxed Exposed Copper Trapdoor', stack: 64 },
      { id: 'waxed-weathered-copper-trapdoor', name: 'Waxed Weathered Copper Trapdoor', stack: 64 },
      { id: 'waxed-oxidized-copper-trapdoor', name: 'Waxed Oxidized Copper Trapdoor', stack: 64 },

      // Chiseled Copper (1.21 Update)
      { id: 'chiseled-copper', name: 'Chiseled Copper', stack: 64 },
      { id: 'exposed-chiseled-copper', name: 'Exposed Chiseled Copper', stack: 64 },
      { id: 'weathered-chiseled-copper', name: 'Weathered Chiseled Copper', stack: 64 },
      { id: 'oxidized-chiseled-copper', name: 'Oxidized Chiseled Copper', stack: 64 },
      { id: 'waxed-chiseled-copper', name: 'Waxed Chiseled Copper', stack: 64 },
      { id: 'waxed-exposed-chiseled-copper', name: 'Waxed Exposed Chiseled Copper', stack: 64 },
      { id: 'waxed-weathered-chiseled-copper', name: 'Waxed Weathered Chiseled Copper', stack: 64 },
      { id: 'waxed-oxidized-chiseled-copper', name: 'Waxed Oxidized Chiseled Copper', stack: 64 },

      // Bars and Chains (from your list)
      { id: 'copper-bars', name: 'Copper Bars', stack: 64 },
      { id: 'exposed-copper-bars', name: 'Exposed Copper Bars', stack: 64 },
      { id: 'weathered-copper-bars', name: 'Weathered Copper Bars', stack: 64 },
      { id: 'oxidized-copper-bars', name: 'Oxidized Copper Bars', stack: 64 },
      { id: 'waxed-copper-bars', name: 'Waxed Copper Bars', stack: 64 },
      { id: 'waxed-exposed-copper-bars', name: 'Waxed Exposed Copper Bars', stack: 64 },
      { id: 'waxed-weathered-copper-bars', name: 'Waxed Weathered Copper Bars', stack: 64 },
      { id: 'waxed-oxidized-copper-bars', name: 'Waxed Oxidized Copper Bars', stack: 64 },
      { id: 'copper-chain', name: 'Copper Chain', stack: 64 },
      { id: 'exposed-copper-chain', name: 'Exposed Copper Chain', stack: 64 },
      { id: 'weathered-copper-chain', name: 'Weathered Copper Chain', stack: 64 },
      { id: 'oxidized-copper-chain', name: 'Oxidized Copper Chain', stack: 64 },
      { id: 'waxed-copper-chain', name: 'Waxed Copper Chain', stack: 64 },
      { id: 'waxed-exposed-copper-chain', name: 'Waxed Exposed Copper Chain', stack: 64 },
      { id: 'waxed-weathered-copper-chain', name: 'Waxed Weathered Copper Chain', stack: 64 },
      { id: 'waxed-oxidized-copper-chain', name: 'Waxed Oxidized Copper Chain', stack: 64 } 
    ],

   // === COLORED BLOCKS ===
    concrete: [
      // === CONCRETE (Solid) ===
      { id: 'white-concrete', name: 'White Concrete', stack: 64 },
      { id: 'orange-concrete', name: 'Orange Concrete', stack: 64 },
      { id: 'magenta-concrete', name: 'Magenta Concrete', stack: 64 },
      { id: 'light-blue-concrete', name: 'Light Blue Concrete', stack: 64 },
      { id: 'yellow-concrete', name: 'Yellow Concrete', stack: 64 },
      { id: 'lime-concrete', name: 'Lime Concrete', stack: 64 },
      { id: 'pink-concrete', name: 'Pink Concrete', stack: 64 },
      { id: 'gray-concrete', name: 'Gray Concrete', stack: 64 },
      { id: 'light-gray-concrete', name: 'Light Gray Concrete', stack: 64 },
      { id: 'cyan-concrete', name: 'Cyan Concrete', stack: 64 },
      { id: 'purple-concrete', name: 'Purple Concrete', stack: 64 },
      { id: 'blue-concrete', name: 'Blue Concrete', stack: 64 },
      { id: 'brown-concrete', name: 'Brown Concrete', stack: 64 },
      { id: 'green-concrete', name: 'Green Concrete', stack: 64 },
      { id: 'red-concrete', name: 'Red Concrete', stack: 64 },
      { id: 'black-concrete', name: 'Black Concrete', stack: 64 },
      
      // === CONCRETE POWDER ===
      { id: 'white-concrete-powder', name: 'White Concrete Powder', stack: 64 },
      { id: 'orange-concrete-powder', name: 'Orange Concrete Powder', stack: 64 },
      { id: 'magenta-concrete-powder', name: 'Magenta Concrete Powder', stack: 64 },
      { id: 'light-blue-concrete-powder', name: 'Light Blue Concrete Powder', stack: 64 },
      { id: 'yellow-concrete-powder', name: 'Yellow Concrete Powder', stack: 64 },
      { id: 'lime-concrete-powder', name: 'Lime Concrete Powder', stack: 64 },
      { id: 'pink-concrete-powder', name: 'Pink Concrete Powder', stack: 64 },
      { id: 'gray-concrete-powder', name: 'Gray Concrete Powder', stack: 64 },
      { id: 'light-gray-concrete-powder', name: 'Light Gray Concrete Powder', stack: 64 },
      { id: 'cyan-concrete-powder', name: 'Cyan Concrete Powder', stack: 64 },
      { id: 'purple-concrete-powder', name: 'Purple Concrete Powder', stack: 64 },
      { id: 'blue-concrete-powder', name: 'Blue Concrete Powder', stack: 64 },
      { id: 'brown-concrete-powder', name: 'Brown Concrete Powder', stack: 64 },
      { id: 'green-concrete-powder', name: 'Green Concrete Powder', stack: 64 },
      { id: 'red-concrete-powder', name: 'Red Concrete Powder', stack: 64 },
      { id: 'black-concrete-powder', name: 'Black Concrete Powder', stack: 64 }
    ],

   volcanic: [
      // Cinnabar Family
      { id: 'cinnabar', name: 'Cinnabar', stack: 64 },
      { id: 'cinnabar-stairs', name: 'Cinnabar Stairs', stack: 64 },
      { id: 'cinnabar-slab', name: 'Cinnabar Slab', stack: 64 },
      { id: 'cinnabar-wall', name: 'Cinnabar Wall', stack: 64 },
      { id: 'polished-cinnabar', name: 'Polished Cinnabar', stack: 64 },
      { id: 'polished-cinnabar-stairs', name: 'Polished Cinnabar Stairs', stack: 64 },
      { id: 'polished-cinnabar-slab', name: 'Polished Cinnabar Slab', stack: 64 },
      { id: 'polished-cinnabar-wall', name: 'Polished Cinnabar Wall', stack: 64 },
      { id: 'cinnabar-bricks', name: 'Cinnabar Bricks', stack: 64 },
      { id: 'cinnabar-brick-stairs', name: 'Cinnabar Brick Stairs', stack: 64 },
      { id: 'cinnabar-brick-slab', name: 'Cinnabar Brick Slab', stack: 64 },
      { id: 'cinnabar-brick-wall', name: 'Cinnabar Brick Wall', stack: 64 },
      { id: 'chiseled-cinnabar', name: 'Chiseled Cinnabar', stack: 64 },

      // Sulfur Family
      { id: 'sulfur', name: 'Sulfur', stack: 64 },
      { id: 'sulfur-stairs', name: 'Sulfur Stairs', stack: 64 },
      { id: 'sulfur-slab', name: 'Sulfur Slab', stack: 64 },
      { id: 'sulfur-wall', name: 'Sulfur Wall', stack: 64 },
      { id: 'polished-sulfur', name: 'Polished Sulfur', stack: 64 },
      { id: 'polished-sulfur-stairs', name: 'Polished Sulfur Stairs', stack: 64 },
      { id: 'polished-sulfur-slab', name: 'Polished Sulfur Slab', stack: 64 },
      { id: 'polished-sulfur-wall', name: 'Polished Sulfur Wall', stack: 64 },
      { id: 'sulfur-bricks', name: 'Sulfur Bricks', stack: 64 },
      { id: 'sulfur-brick-stairs', name: 'Sulfur Brick Stairs', stack: 64 },
      { id: 'sulfur-brick-slab', name: 'Sulfur Brick Slab', stack: 64 },
      { id: 'sulfur-brick-wall', name: 'Sulfur Brick Wall', stack: 64 },
      { id: 'chiseled-sulfur', name: 'Chiseled Sulfur', stack: 64 },
      { id: 'potent-sulfur', name: 'Potent Sulfur', stack: 64 }
    ],
      
    wool: [
        // === WOOL BLOCKS ===
        { id: 'white-wool', name: 'White Wool', stack: 64 },
        { id: 'orange-wool', name: 'Orange Wool', stack: 64 },
        { id: 'magenta-wool', name: 'Magenta Wool', stack: 64 },
        { id: 'light-blue-wool', name: 'Light Blue Wool', stack: 64 },
        { id: 'yellow-wool', name: 'Yellow Wool', stack: 64 },
        { id: 'lime-wool', name: 'Lime Wool', stack: 64 },
        { id: 'pink-wool', name: 'Pink Wool', stack: 64 },
        { id: 'gray-wool', name: 'Gray Wool', stack: 64 },
        { id: 'light-gray-wool', name: 'Light Gray Wool', stack: 64 },
        { id: 'cyan-wool', name: 'Cyan Wool', stack: 64 },
        { id: 'purple-wool', name: 'Purple Wool', stack: 64 },
        { id: 'blue-wool', name: 'Blue Wool', stack: 64 },
        { id: 'brown-wool', name: 'Brown Wool', stack: 64 },
        { id: 'green-wool', name: 'Green Wool', stack: 64 },
        { id: 'red-wool', name: 'Red Wool', stack: 64 },
        { id: 'black-wool', name: 'Black Wool', stack: 64 },

        // === CARPETS ===
        { id: 'white-carpet', name: 'White Carpet', stack: 64 },
        { id: 'orange-carpet', name: 'Orange Carpet', stack: 64 },
        { id: 'magenta-carpet', name: 'Magenta Carpet', stack: 64 },
        { id: 'light-blue-carpet', name: 'Light Blue Carpet', stack: 64 },
        { id: 'yellow-carpet', name: 'Yellow Carpet', stack: 64 },
        { id: 'lime-carpet', name: 'Lime Carpet', stack: 64 },
        { id: 'pink-carpet', name: 'Pink Carpet', stack: 64 },
        { id: 'gray-carpet', name: 'Gray Carpet', stack: 64 },
        { id: 'light-gray-carpet', name: 'Light Gray Carpet', stack: 64 },
        { id: 'cyan-carpet', name: 'Cyan Carpet', stack: 64 },
        { id: 'purple-carpet', name: 'Purple Carpet', stack: 64 },
        { id: 'blue-carpet', name: 'Blue Carpet', stack: 64 },
        { id: 'brown-carpet', name: 'Brown Carpet', stack: 64 },
        { id: 'green-carpet', name: 'Green Carpet', stack: 64 },
        { id: 'red-carpet', name: 'Red Carpet', stack: 64 },
        { id: 'black-carpet', name: 'Black Carpet', stack: 64 }
      ],

      terracotta: [
        // === TERRACOTTA (Plain/Stained) ===
        { id: 'white-terracotta', name: 'White Terracotta', stack: 64 },
        { id: 'orange-terracotta', name: 'Orange Terracotta', stack: 64 },
        { id: 'magenta-terracotta', name: 'Magenta Terracotta', stack: 64 },
        { id: 'light-blue-terracotta', name: 'Light Blue Terracotta', stack: 64 },
        { id: 'yellow-terracotta', name: 'Yellow Terracotta', stack: 64 },
        { id: 'lime-terracotta', name: 'Lime Terracotta', stack: 64 },
        { id: 'pink-terracotta', name: 'Pink Terracotta', stack: 64 },
        { id: 'gray-terracotta', name: 'Gray Terracotta', stack: 64 },
        { id: 'light-gray-terracotta', name: 'Light Gray Terracotta', stack: 64 },
        { id: 'cyan-terracotta', name: 'Cyan Terracotta', stack: 64 },
        { id: 'purple-terracotta', name: 'Purple Terracotta', stack: 64 },
        { id: 'blue-terracotta', name: 'Blue Terracotta', stack: 64 },
        { id: 'brown-terracotta', name: 'Brown Terracotta', stack: 64 },
        { id: 'green-terracotta', name: 'Green Terracotta', stack: 64 },
        { id: 'red-terracotta', name: 'Red Terracotta', stack: 64 },
        { id: 'black-terracotta', name: 'Black Terracotta', stack: 64 },

        // === GLAZED TERRACOTTA ===
        { id: 'white-glazed-terracotta', name: 'White Glazed Terracotta', stack: 64 },
        { id: 'orange-glazed-terracotta', name: 'Orange Glazed Terracotta', stack: 64 },
        { id: 'magenta-glazed-terracotta', name: 'Magenta Glazed Terracotta', stack: 64 },
        { id: 'light-blue-glazed-terracotta', name: 'Light Blue Glazed Terracotta', stack: 64 },
        { id: 'yellow-glazed-terracotta', name: 'Yellow Glazed Terracotta', stack: 64 },
        { id: 'lime-glazed-terracotta', name: 'Lime Glazed Terracotta', stack: 64 },
        { id: 'pink-glazed-terracotta', name: 'Pink Glazed Terracotta', stack: 64 },
        { id: 'gray-glazed-terracotta', name: 'Gray Glazed Terracotta', stack: 64 },
        { id: 'light-gray-glazed-terracotta', name: 'Light Gray Glazed Terracotta', stack: 64 },
        { id: 'cyan-glazed-terracotta', name: 'Cyan Glazed Terracotta', stack: 64 },
        { id: 'purple-glazed-terracotta', name: 'Purple Glazed Terracotta', stack: 64 },
        { id: 'blue-glazed-terracotta', name: 'Blue Glazed Terracotta', stack: 64 },
        { id: 'brown-glazed-terracotta', name: 'Brown Glazed Terracotta', stack: 64 },
        { id: 'green-glazed-terracotta', name: 'Green Glazed Terracotta', stack: 64 },
        { id: 'red-glazed-terracotta', name: 'Red Glazed Terracotta', stack: 64 },
        { id: 'black-glazed-terracotta', name: 'Black Glazed Terracotta', stack: 64 }
      ],

      stained_glass: [
        // === GLASS BLOCKS ===
        { id: 'glass', name: 'Glass', stack: 64 },
        { id: 'tinted-glass', name: 'Tinted Glass', stack: 64 },
        { id: 'white-stained-glass', name: 'White Stained Glass', stack: 64 },
        { id: 'orange-stained-glass', name: 'Orange Stained Glass', stack: 64 },
        { id: 'magenta-stained-glass', name: 'Magenta Stained Glass', stack: 64 },
        { id: 'light-blue-stained-glass', name: 'Light Blue Stained Glass', stack: 64 },
        { id: 'yellow-stained-glass', name: 'Yellow Stained Glass', stack: 64 },
        { id: 'lime-stained-glass', name: 'Lime Stained Glass', stack: 64 },
        { id: 'pink-stained-glass', name: 'Pink Stained Glass', stack: 64 },
        { id: 'gray-stained-glass', name: 'Gray Stained Glass', stack: 64 },
        { id: 'light-gray-stained-glass', name: 'Light Gray Stained Glass', stack: 64 },
        { id: 'cyan-stained-glass', name: 'Cyan Stained Glass', stack: 64 },
        { id: 'purple-stained-glass', name: 'Purple Stained Glass', stack: 64 },
        { id: 'blue-stained-glass', name: 'Blue Stained Glass', stack: 64 },
        { id: 'brown-stained-glass', name: 'Brown Stained Glass', stack: 64 },
        { id: 'green-stained-glass', name: 'Green Stained Glass', stack: 64 },
        { id: 'red-stained-glass', name: 'Red Stained Glass', stack: 64 },
        { id: 'black-stained-glass', name: 'Black Stained Glass', stack: 64 },

        // === GLASS PANES ===
        { id: 'glass-pane', name: 'Glass Pane', stack: 64 },
        { id: 'white-stained-glass-pane', name: 'White Stained Glass Pane', stack: 64 },
        { id: 'orange-stained-glass-pane', name: 'Orange Stained Glass Pane', stack: 64 },
        { id: 'magenta-stained-glass-pane', name: 'Magenta Stained Glass Pane', stack: 64 },
        { id: 'light-blue-stained-glass-pane', name: 'Light Blue Stained Glass Pane', stack: 64 },
        { id: 'yellow-stained-glass-pane', name: 'Yellow Stained Glass Pane', stack: 64 },
        { id: 'lime-stained-glass-pane', name: 'Lime Stained Glass Pane', stack: 64 },
        { id: 'pink-stained-glass-pane', name: 'Pink Stained Glass Pane', stack: 64 },
        { id: 'gray-stained-glass-pane', name: 'Gray Stained Glass Pane', stack: 64 },
        { id: 'light-gray-stained-glass-pane', name: 'Light Gray Stained Glass Pane', stack: 64 },
        { id: 'cyan-stained-glass-pane', name: 'Cyan Stained Glass Pane', stack: 64 },
        { id: 'purple-stained-glass-pane', name: 'Purple Stained Glass Pane', stack: 64 },
        { id: 'blue-stained-glass-pane', name: 'Blue Stained Glass Pane', stack: 64 },
        { id: 'brown-stained-glass-pane', name: 'Brown Stained Glass Pane', stack: 64 },
        { id: 'green-stained-glass-pane', name: 'Green Stained Glass Pane', stack: 64 },
        { id: 'red-stained-glass-pane', name: 'Red Stained Glass Pane', stack: 64 },
        { id: 'black-stained-glass-pane', name: 'Black Stained Glass Pane', stack: 64 }
      ],
  

      glass_lighting: [
        { id: 'torch', name: 'Torch', stack: 64 },
        { id: 'soul-torch', name: 'Soul Torch', stack: 64 },
        { id: 'copper-torch', name: 'Copper Torch', stack: 64 },
        { id: 'lantern', name: 'Lantern', stack: 64 },
        { id: 'soul-lantern', name: 'Soul Lantern', stack: 64 },
        { id: 'glowstone', name: 'Glowstone', stack: 64 },
        { id: 'shroomlight', name: 'Shroomlight', stack: 64 },
        { id: 'candle', name: 'Candle', stack: 64 },
        { id: 'white-candle', name: 'White Candle', stack: 64 },
        { id: 'orange-candle', name: 'Orange Candle', stack: 64 },
        { id: 'magenta-candle', name: 'Magenta Candle', stack: 64 },
        { id: 'light-blue-candle', name: 'Light Blue Candle', stack: 64 },
        { id: 'yellow-candle', name: 'Yellow Candle', stack: 64 },
        { id: 'lime-candle', name: 'Lime Candle', stack: 64 },
        { id: 'pink-candle', name: 'Pink Candle', stack: 64 },
        { id: 'gray-candle', name: 'Gray Candle', stack: 64 },
        { id: 'light-gray-candle', name: 'Light Gray Candle', stack: 64 },
        { id: 'cyan-candle', name: 'Cyan Candle', stack: 64 },
        { id: 'purple-candle', name: 'Purple Candle', stack: 64 },
        { id: 'blue-candle', name: 'Blue Candle', stack: 64 },
        { id: 'brown-candle', name: 'Brown Candle', stack: 64 },
        { id: 'green-candle', name: 'Green Candle', stack: 64 },
        { id: 'red-candle', name: 'Red Candle', stack: 64 },
        { id: 'black-candle', name: 'Black Candle', stack: 64 },  
        { id: 'sea-lantern', name: 'Sea Lantern', stack: 64 },    
        { id: 'end-rod', name: 'End Rod', stack: 64 },
        { id: 'sea-pickle', name: 'Sea Pickle', stack: 64 },
        { id: 'copper-lantern', name: 'Copper Lantern', stack: 64 },
        { id: 'exposed-copper-lantern', name: 'Exposed Copper Lantern', stack: 64 },
        { id: 'weathered-copper-lantern', name: 'Weathered Copper Lantern', stack: 64 },
        { id: 'oxidized-copper-lantern', name: 'Oxidized Copper Lantern', stack: 64 },
        { id: 'waxed-copper-lantern', name: 'Waxed Copper Lantern', stack: 64 },
        { id: 'waxed-exposed-copper-lantern', name: 'Waxed Exposed Copper Lantern', stack: 64 },
        { id: 'waxed-weathered-copper-lantern', name: 'Waxed Weathered Copper Lantern', stack: 64 },
        { id: 'waxed-oxidized-copper-lantern', name: 'Waxed Oxidized Copper Lantern', stack: 64 }
      ],
  


     // === FUNCTIONAL BLOCKS ===

     storage: [        
        { id: 'chest', name: 'Chest', stack: 64 },
        { id: 'trapped-chest', name: 'Trapped Chest', stack: 64 },
        { id: 'ender-chest', name: 'Ender Chest', stack: 64 },
        { id: 'copper-chest', name: 'Copper Chest', stack: 64 },
        { id: 'exposed-copper-chest', name: 'Exposed Copper Chest', stack: 64 },
        { id: 'weathered-copper-chest', name: 'Weathered Copper Chest', stack: 64 },
        { id: 'oxidized-copper-chest', name: 'Oxidized Copper Chest', stack: 64 },
        { id: 'waxed-copper-chest', name: 'Waxed Copper Chest', stack: 64 },
        { id: 'waxed-exposed-copper-chest', name: 'Waxed Exposed Copper Chest', stack: 64 },
        { id: 'waxed-weathered-copper-chest', name: 'Waxed Weathered Copper Chest', stack: 64 },
        { id: 'waxed-oxidized-copper-chest', name: 'Waxed Oxidized Copper Chest', stack: 64 },
        { id: 'shulker-box', name: 'Shulker Box', stack: 1 },
        { id: 'white-shulker-box', name: 'White Shulker Box', stack: 1 },
        { id: 'orange-shulker-box', name: 'Orange Shulker Box', stack: 1 },
        { id: 'magenta-shulker-box', name: 'Magenta Shulker Box', stack: 1 },
        { id: 'light-blue-shulker-box', name: 'Light Blue Shulker Box', stack: 1 },
        { id: 'yellow-shulker-box', name: 'Yellow Shulker Box', stack: 1 },
        { id: 'lime-shulker-box', name: 'Lime Shulker Box', stack: 1 },
        { id: 'pink-shulker-box', name: 'Pink Shulker Box', stack: 1 },
        { id: 'gray-shulker-box', name: 'Gray Shulker Box', stack: 1 },
        { id: 'light-gray-shulker-box', name: 'Light Gray Shulker Box', stack: 1 },
        { id: 'cyan-shulker-box', name: 'Cyan Shulker Box', stack: 1 },
        { id: 'purple-shulker-box', name: 'Purple Shulker Box', stack: 1 },
        { id: 'blue-shulker-box', name: 'Blue Shulker Box', stack: 1 },
        { id: 'brown-shulker-box', name: 'Brown Shulker Box', stack: 1 },
        { id: 'green-shulker-box', name: 'Green Shulker Box', stack: 1 },
        { id: 'red-shulker-box', name: 'Red Shulker Box', stack: 1 },
        { id: 'black-shulker-box', name: 'Black Shulker Box', stack: 1 }
      ],

      functional: [
        { id: 'crafting-table', name: 'Crafting Table', stack: 64 },
        { id: 'furnace', name: 'Furnace', stack: 64 },    
        { id: 'barrel', name: 'Barrel', stack: 64 },
        { id: 'smoker', name: 'Smoker', stack: 64 },
        { id: 'blast-furnace', name: 'Blast Furnace', stack: 64 },
        { id: 'anvil', name: 'Anvil', stack: 64 },
        { id: 'brewing-stand', name: 'Brewing Stand', stack: 64 },
        { id: 'enchanting-table', name: 'Enchanting Table', stack: 64 },
        { id: 'grindstone', name: 'Grindstone', stack: 64 },
        { id: 'loom', name: 'Loom', stack: 64 },
        { id: 'smithing-table', name: 'Smithing Table', stack: 64 },
        { id: 'cartography-table', name: 'Cartography Table', stack: 64 },
        { id: 'fletching-table', name: 'Fletching Table', stack: 64 },
        { id: 'composter', name: 'Composter', stack: 64 },
        { id: 'lectern', name: 'Lectern', stack: 64 },
        { id: 'cauldron', name: 'Cauldron', stack: 64 },
      ],

      beds: [
        { id: 'white-bed', name: 'White Bed', stack: 1 },
        { id: 'orange-bed', name: 'Orange Bed', stack: 1 },
        { id: 'magenta-bed', name: 'Magenta Bed', stack: 1 },
        { id: 'light-blue-bed', name: 'Light Blue Bed', stack: 1 },
        { id: 'yellow-bed', name: 'Yellow Bed', stack: 1 },
        { id: 'lime-bed', name: 'Lime Bed', stack: 1 },
        { id: 'pink-bed', name: 'Pink Bed', stack: 1 },
        { id: 'gray-bed', name: 'Gray Bed', stack: 1 },
        { id: 'light-gray-bed', name: 'Light Gray Bed', stack: 1 },
        { id: 'cyan-bed', name: 'Cyan Bed', stack: 1 },
        { id: 'purple-bed', name: 'Purple Bed', stack: 1 },
        { id: 'blue-bed', name: 'Blue Bed', stack: 1 },
        { id: 'brown-bed', name: 'Brown Bed', stack: 1 },
        { id: 'green-bed', name: 'Green Bed', stack: 1 },
        { id: 'red-bed', name: 'Red Bed', stack: 1 },
        { id: 'black-bed', name: 'Black Bed', stack: 1 }
      ],

      banners: [
        { id: 'white-banner', name: 'White Banner', stack: 16 },
        { id: 'orange-banner', name: 'Orange Banner', stack: 16 },
        { id: 'magenta-banner', name: 'Magenta Banner', stack: 16 },
        { id: 'light-blue-banner', name: 'Light Blue Banner', stack: 16 },
        { id: 'yellow-banner', name: 'Yellow Banner', stack: 16 },
        { id: 'lime-banner', name: 'Lime Banner', stack: 16 },
        { id: 'pink-banner', name: 'Pink Banner', stack: 16 },
        { id: 'gray-banner', name: 'Gray Banner', stack: 16 },
        { id: 'light-gray-banner', name: 'Light Gray Banner', stack: 16 },
        { id: 'cyan-banner', name: 'Cyan Banner', stack: 16 },
        { id: 'purple-banner', name: 'Purple Banner', stack: 16 },
        { id: 'blue-banner', name: 'Blue Banner', stack: 16 },
        { id: 'brown-banner', name: 'Brown Banner', stack: 16 },
        { id: 'green-banner', name: 'Green Banner', stack: 16 },
        { id: 'red-banner', name: 'Red Banner', stack: 16 },
        { id: 'black-banner', name: 'Black Banner', stack: 16 }
      ],

      bundles: [
        { id: 'bundle', name: 'Bundle', stack: 1 },
        { id: 'white-bundle', name: 'White Bundle', stack: 1 },
        { id: 'orange-bundle', name: 'Orange Bundle', stack: 1 },
        { id: 'magenta-bundle', name: 'Magenta Bundle', stack: 1 },
        { id: 'light-blue-bundle', name: 'Light Blue Bundle', stack: 1 },
        { id: 'yellow-bundle', name: 'Yellow Bundle', stack: 1 },
        { id: 'lime-bundle', name: 'Lime Bundle', stack: 1 },
        { id: 'pink-bundle', name: 'Pink Bundle', stack: 1 },
        { id: 'gray-bundle', name: 'Gray Bundle', stack: 1 },
        { id: 'light-gray-bundle', name: 'Light Gray Bundle', stack: 1 },
        { id: 'cyan-bundle', name: 'Cyan Bundle', stack: 1 },
        { id: 'purple-bundle', name: 'Purple Bundle', stack: 1 },
        { id: 'blue-bundle', name: 'Blue Bundle', stack: 1 },
        { id: 'brown-bundle', name: 'Brown Bundle', stack: 1 },
        { id: 'green-bundle', name: 'Green Bundle', stack: 1 },
        { id: 'red-bundle', name: 'Red Bundle', stack: 1 },
        { id: 'black-bundle', name: 'Black Bundle', stack: 1 }
      ],

      dyes: [
        { id: 'white-dye', name: 'White Dye', stack: 64 },
        { id: 'orange-dye', name: 'Orange Dye', stack: 64 },
        { id: 'magenta-dye', name: 'Magenta Dye', stack: 64 },
        { id: 'light-blue-dye', name: 'Light Blue Dye', stack: 64 },
        { id: 'yellow-dye', name: 'Yellow Dye', stack: 64 },
        { id: 'lime-dye', name: 'Lime Dye', stack: 64 },
        { id: 'pink-dye', name: 'Pink Dye', stack: 64 },
        { id: 'gray-dye', name: 'Gray Dye', stack: 64 },
        { id: 'light-gray-dye', name: 'Light Gray Dye', stack: 64 },
        { id: 'cyan-dye', name: 'Cyan Dye', stack: 64 },
        { id: 'purple-dye', name: 'Purple Dye', stack: 64 },
        { id: 'blue-dye', name: 'Blue Dye', stack: 64 },
        { id: 'brown-dye', name: 'Brown Dye', stack: 64 },
        { id: 'green-dye', name: 'Green Dye', stack: 64 },
        { id: 'red-dye', name: 'Red Dye', stack: 64 },
        { id: 'black-dye', name: 'Black Dye', stack: 64 }
      ],



     // === REDSTONE BLOCKS ===
      redstone: [
        { id: 'redstone', name: 'Redstone Dust', stack: 64 },
        { id: 'redstone-torch', name: 'Redstone Torch', stack: 64 },
        { id: 'redstone-repeater', name: 'Redstone Repeater', stack: 64 },
        { id: 'redstone-comparator', name: 'Redstone Comparator', stack: 64 },
        // { id: 'chest', name: 'Chest', stack: 64 },
        { id: 'crafter', name: 'Crafter', stack: 64 },
        { id: 'piston', name: 'Piston', stack: 64 },
        { id: 'sticky-piston', name: 'Sticky Piston', stack: 64 },
        { id: 'observer', name: 'Observer', stack: 64 },
        { id: 'hopper', name: 'Hopper', stack: 64 },
        { id: 'dropper', name: 'Dropper', stack: 64 },
        { id: 'dispenser', name: 'Dispenser', stack: 64 },
        { id: 'note-block', name: 'Note Block', stack: 64 },
        { id: 'redstone-lamp', name: 'Redstone Lamp', stack: 64 },
        { id: 'lever', name: 'Lever', stack: 64 },
        { id: 'tripwire-hook', name: 'Tripwire Hook', stack: 64 },
        { id: 'block-of-redstone', name: 'Block of Redstone', stack: 64 },
        { id: 'slime-block', name: 'Slime Block', stack: 64 },
        { id: 'honey-block', name: 'Honey Block', stack: 64 },
        { id: 'target', name: 'Target', stack: 64 },
        // { id: 'trapped-chest', name: 'Trapped Chest', stack: 64 },
        { id: 'daylight-detector', name: 'Daylight Detector', stack: 64 },
        { id: 'sculk-sensor', name: 'Sculk Sensor', stack: 64 },
        { id: 'tnt', name: 'TNT', stack: 64 },
        { id: 'rail', name: 'Rail', stack: 64 },
        { id: 'powered-rail', name: 'Powered Rail', stack: 64 },
        { id: 'detector-rail', name: 'Detector Rail', stack: 64 },
        { id: 'activator-rail', name: 'Activator Rail', stack: 64 },
        { id: 'minecart', name: 'Minecart', stack: 1 },
        { id: 'chest-minecart', name: 'Minecart with Chest', stack: 1 },
        { id: 'furnace-minecart', name: 'Minecart with Furnace', stack: 1 },
        { id: 'hopper-minecart', name: 'Minecart with Hopper', stack: 1 },
        { id: 'tnt-minecart', name: 'Minecart with TNT', stack: 1 },
        { id: 'command-block-minecart', name: 'Minecart with Command Block', stack: 1 }
      ],

      buttons: [
        { id: 'oak-button', name: 'Oak Button', stack: 64 },
        { id: 'oak-pressure-plate', name: 'Oak Pressure Plate', stack: 64 },
        { id: 'spruce-button', name: 'Spruce Button', stack: 64 },
        { id: 'spruce-pressure-plate', name: 'Spruce Pressure Plate', stack: 64 },
        { id: 'birch-button', name: 'Birch Button', stack: 64 },
        { id: 'birch-pressure-plate', name: 'Birch Pressure Plate', stack: 64 },
        { id: 'jungle-button', name: 'Jungle Button', stack: 64 },
        { id: 'jungle-pressure-plate', name: 'Jungle Pressure Plate', stack: 64 },
        { id: 'acacia-button', name: 'Acacia Button', stack: 64 },
        { id: 'acacia-pressure-plate', name: 'Acacia Pressure Plate', stack: 64 },
        { id: 'dark-oak-button', name: 'Dark Oak Button', stack: 64 },
        { id: 'dark-oak-pressure-plate', name: 'Dark Oak Pressure Plate', stack: 64 },
        { id: 'mangrove-button', name: 'Mangrove Button', stack: 64 },
        { id: 'mangrove-pressure-plate', name: 'Mangrove Pressure Plate', stack: 64 },
        { id: 'cherry-button', name: 'Cherry Button', stack: 64 },
        { id: 'cherry-pressure-plate', name: 'Cherry Pressure Plate', stack: 64 },
        { id: 'bamboo-button', name: 'Bamboo Button', stack: 64 },
        { id: 'bamboo-pressure-plate', name: 'Bamboo Pressure Plate', stack: 64 },
        { id: 'crimson-button', name: 'Crimson Button', stack: 64 },
        { id: 'crimson-pressure-plate', name: 'Crimson Pressure Plate', stack: 64 },
        { id: 'warped-button', name: 'Warped Button', stack: 64 },
        { id: 'warped-pressure-plate', name: 'Warped Pressure Plate', stack: 64 },
        { id: 'stone-button', name: 'Stone Button', stack: 64 },
        { id: 'stone-pressure-plate', name: 'Stone Pressure Plate', stack: 64 },
        { id: 'polished-blackstone-button', name: 'Polished Blackstone Button', stack: 64 },
        { id: 'polished-blackstone-pressure-plate', name: 'Polished Blackstone Pressure Plate', stack: 64 },
        { id: 'light-weighted-pressure-plate', name: 'Light Weighted Pressure Plate', stack: 64 },
        { id: 'heavy-weighted-pressure-plate', name: 'Heavy Weighted Pressure Plate', stack: 64 },
        { id: 'pale-oak-button', name: 'Pale Oak Button', stack: 64 },
        { id: 'pale-oak-pressure-plate', name: 'Pale Oak Pressure Plate', stack: 64 }
      ],


           
 // === TOOLS & ARMOR ===
      tools: [
        { id: 'wooden-sword', name: 'Wooden Sword', stack: 1 },
        { id: 'wooden-pickaxe', name: 'Wooden Pickaxe', stack: 1 },
        { id: 'wooden-axe', name: 'Wooden Axe', stack: 1 },
        { id: 'wooden-shovel', name: 'Wooden Shovel', stack: 1 },
        { id: 'wooden-hoe', name: 'Wooden Hoe', stack: 1 },
        { id: 'stone-sword', name: 'Stone Sword', stack: 1 },
        { id: 'stone-pickaxe', name: 'Stone Pickaxe', stack: 1 },
        { id: 'stone-axe', name: 'Stone Axe', stack: 1 },
        { id: 'stone-shovel', name: 'Stone Shovel', stack: 1 },
        { id: 'stone-hoe', name: 'Stone Hoe', stack: 1 },
        { id: 'copper-sword', name: 'Copper Sword', stack: 1 },
        { id: 'copper-pickaxe', name: 'Copper Pickaxe', stack: 1 },
        { id: 'copper-axe', name: 'Copper Axe', stack: 1 },
        { id: 'copper-shovel', name: 'Copper Shovel', stack: 1 },
        { id: 'copper-hoe', name: 'Copper Hoe', stack: 1 },
        { id: 'iron-sword', name: 'Iron Sword', stack: 1 },
        { id: 'iron-pickaxe', name: 'Iron Pickaxe', stack: 1 },
        { id: 'iron-axe', name: 'Iron Axe', stack: 1 },
        { id: 'iron-shovel', name: 'Iron Shovel', stack: 1 },
        { id: 'iron-hoe', name: 'Iron Hoe', stack: 1 },
        { id: 'golden-sword', name: 'Golden Sword', stack: 1 },
        { id: 'golden-pickaxe', name: 'Golden Pickaxe', stack: 1 },
        { id: 'golden-axe', name: 'Golden Axe', stack: 1 },
        { id: 'golden-shovel', name: 'Golden Shovel', stack: 1 },
        { id: 'golden-hoe', name: 'Golden Hoe', stack: 1 },
        { id: 'diamond-sword', name: 'Diamond Sword', stack: 1 },
        { id: 'diamond-pickaxe', name: 'Diamond Pickaxe', stack: 1 },
        { id: 'diamond-axe', name: 'Diamond Axe', stack: 1 },
        { id: 'diamond-shovel', name: 'Diamond Shovel', stack: 1 },
        { id: 'diamond-hoe', name: 'Diamond Hoe', stack: 1 },
        { id: 'netherite-sword', name: 'Netherite Sword', stack: 1 },
        { id: 'netherite-pickaxe', name: 'Netherite Pickaxe', stack: 1 },
        { id: 'netherite-axe', name: 'Netherite Axe', stack: 1 },
        { id: 'netherite-shovel', name: 'Netherite Shovel', stack: 1 },
        { id: 'netherite-hoe', name: 'Netherite Hoe', stack: 1 },
        { id: 'wooden-spear', name: 'Wooden Spear', stack: 1 },
        { id: 'stone-spear', name: 'Stone Spear', stack: 1 },
        { id: 'copper-spear', name: 'Copper Spear', stack: 1 },
        { id: 'iron-spear', name: 'Iron Spear', stack: 1 },
        { id: 'golden-spear', name: 'Golden Spear', stack: 1 },
        { id: 'diamond-spear', name: 'Diamond Spear', stack: 1 },
        { id: 'netherite-spear', name: 'Netherite Spear', stack: 1 },
        { id: 'bow', name: 'Bow', stack: 1 },
        { id: 'crossbow', name: 'Crossbow', stack: 1 },
        { id: 'trident', name: 'Trident', stack: 1 },
        { id: 'mace', name: 'Mace', stack: 1 },
        { id: 'shield', name: 'Shield', stack: 1 },  
        { id: 'shears', name: 'Shears', stack: 1 },
        { id: 'fishing-rod', name: 'Fishing Rod', stack: 1 },
        { id: 'flint-and-steel', name: 'Flint and Steel', stack: 1 },               
        { id: 'brush', name: 'Brush', stack: 1 },
        { id: 'spyglass', name: 'Spyglass', stack: 1 }
      ],

      armor: [
        { id: 'leather-cap', name: 'Leather Cap', stack: 1 },
        { id: 'leather-tunic', name: 'Leather Tunic', stack: 1 },
        { id: 'leather-pants', name: 'Leather Pants', stack: 1 },
        { id: 'leather-boots', name: 'Leather Boots', stack: 1 },
        { id: 'chainmail-helmet', name: 'Chainmail Helmet', stack: 1 },
        { id: 'chainmail-chestplate', name: 'Chainmail Chestplate', stack: 1 },
        { id: 'chainmail-leggings', name: 'Chainmail Leggings', stack: 1 },
        { id: 'chainmail-boots', name: 'Chainmail Boots', stack: 1 },
        { id: 'copper-helmet', name: 'Copper Helmet', stack: 1 },
        { id: 'copper-chestplate', name: 'Copper Chestplate', stack: 1 },
        { id: 'copper-leggings', name: 'Copper Leggings', stack: 1 },
        { id: 'copper-boots', name: 'Copper Boots', stack: 1 },
        { id: 'iron-helmet', name: 'Iron Helmet', stack: 1 },
        { id: 'iron-chestplate', name: 'Iron Chestplate', stack: 1 },
        { id: 'iron-leggings', name: 'Iron Leggings', stack: 1 },
        { id: 'iron-boots', name: 'Iron Boots', stack: 1 },
        { id: 'golden-helmet', name: 'Golden Helmet', stack: 1 },
        { id: 'golden-chestplate', name: 'Golden Chestplate', stack: 1 },
        { id: 'golden-leggings', name: 'Golden Leggings', stack: 1 },
        { id: 'golden-boots', name: 'Golden Boots', stack: 1 },
        { id: 'diamond-helmet', name: 'Diamond Helmet', stack: 1 },
        { id: 'diamond-chestplate', name: 'Diamond Chestplate', stack: 1 },
        { id: 'diamond-leggings', name: 'Diamond Leggings', stack: 1 },
        { id: 'diamond-boots', name: 'Diamond Boots', stack: 1 },
        { id: 'netherite-helmet', name: 'Netherite Helmet', stack: 1 },
        { id: 'netherite-chestplate', name: 'Netherite Chestplate', stack: 1 },
        { id: 'netherite-leggings', name: 'Netherite Leggings', stack: 1 },
        { id: 'netherite-boots', name: 'Netherite Boots', stack: 1 }, 
        { id: 'elytra', name: 'Elytra', stack: 1 },
        { id: 'turtle-helmet', name: 'Turtle Helmet', stack: 1 },
        { id: 'wolf-armor', name: 'Wolf Armor', stack: 1 },
        { id: 'copper-nautilus-armor', name: 'Copper Nautilus Armor', stack: 1 },
        { id: 'iron-nautilus-armor', name: 'Iron Nautilus Armor', stack: 1 },
        { id: 'golden-nautilus-armor', name: 'Golden Nautilus Armor', stack: 1 },
        { id: 'diamond-nautilus-armor', name: 'Diamond Nautilus Armor', stack: 1 },
        { id: 'netherite-nautilus-armor', name: 'Netherite Nautilus Armor', stack: 1 },
        { id: 'leather-horse-armor', name: 'Leather Horse Armor', stack: 1 },
        { id: 'copper-horse-armor', name: 'Copper Horse Armor', stack: 1 },
        { id: 'golden-horse-armor', name: 'Golden Horse Armor', stack: 1 },
        { id: 'iron-horse-armor', name: 'Iron Horse Armor', stack: 1 },        
        { id: 'diamond-horse-armor', name: 'Diamond Horse Armor', stack: 1 },
        { id: 'netherite-horse-armor', name: 'Netherite Horse Armor', stack: 1 },         
      ],



  // === FOOD & DRINKS ===
      food: [
        { id: 'apple', name: 'Apple', stack: 64 },
        { id: 'golden-apple', name: 'Golden Apple', stack: 64 },
        { id: 'bread', name: 'Bread', stack: 64 },
        { id: 'cookie', name: 'Cookie', stack: 64 },
        { id: 'cake', name: 'Cake', stack: 1 },
        { id: 'pumpkin-pie', name: 'Pumpkin Pie', stack: 64 },
        { id: 'melon-slice', name: 'Melon Slice', stack: 64 },
        { id: 'baked-potato', name: 'Baked Potato', stack: 64 },
        { id: 'cooked-beef', name: 'Cooked Beef', stack: 64 },
        { id: 'cooked-chicken', name: 'Cooked Chicken', stack: 64 },
        { id: 'cooked-porkchop', name: 'Cooked Porkchop', stack: 64 },
        { id: 'cooked-mutton', name: 'Cooked Mutton', stack: 64 },
        { id: 'cooked-rabbit', name: 'Cooked Rabbit', stack: 64 },
        { id: 'cooked-cod', name: 'Cooked Cod', stack: 64 },
        { id: 'cooked-salmon', name: 'Cooked Salmon', stack: 64 },
        { id: 'raw-cod', name: 'Raw Cod', stack: 64 },
        { id: 'raw-salmon', name: 'Raw Salmon', stack: 64 },
        { id: 'tropical-fish', name: 'Tropical Fish', stack: 64 },
      ],

  
      crops: [
        { id: 'wheat', name: 'Wheat', stack: 64 },
        { id: 'wheat-seeds', name: 'Wheat Seeds', stack: 64 },
        { id: 'carrot', name: 'Carrot', stack: 64 },
        { id: 'potato', name: 'Potato', stack: 64 },
        { id: 'beetroot', name: 'Beetroot', stack: 64 },
        { id: 'beetroot-seeds', name: 'Beetroot Seeds', stack: 64 },
        { id: 'melon', name: 'Melon', stack: 64 },
        { id: 'pumpkin', name: 'Pumpkin', stack: 64 },
        { id: 'sugar-cane', name: 'Sugar Cane', stack: 64 },
        { id: 'cactus', name: 'Cactus', stack: 64 },
        { id: 'bamboo', name: 'Bamboo', stack: 64 },
        { id: 'poppy', name: 'Poppy', stack: 64 },
        { id: 'dandelion', name: 'Dandelion', stack: 64 },
        { id: 'blue-orchid', name: 'Blue Orchid', stack: 64 },
        { id: 'allium', name: 'Allium', stack: 64 },
        { id: 'azure-bluet', name: 'Azure Bluet', stack: 64 },
        { id: 'red-tulip', name: 'Red Tulip', stack: 64 },
        { id: 'orange-tulip', name: 'Orange Tulip', stack: 64 },
        { id: 'white-tulip', name: 'White Tulip', stack: 64 },
        { id: 'pink-tulip', name: 'Pink Tulip', stack: 64 },
        { id: 'oxeye-daisy', name: 'Oxeye Daisy', stack: 64 },
        { id: 'cornflower', name: 'Cornflower', stack: 64 },
        { id: 'lily-of-the-valley', name: 'Lily of the Valley', stack: 64 },
        { id: 'sunflower', name: 'Sunflower', stack: 64 },
        { id: 'lilac', name: 'Lilac', stack: 64 },
        { id: 'rose-bush', name: 'Rose Bush', stack: 64 },
        { id: 'peony', name: 'Peony', stack: 64 },  
        { id: 'oak-sapling', name: 'Oak Sapling', stack: 64 },
        { id: 'spruce-sapling', name: 'Spruce Sapling', stack: 64 },
        { id: 'birch-sapling', name: 'Birch Sapling', stack: 64 },
        { id: 'jungle-sapling', name: 'Jungle Sapling', stack: 64 },
        { id: 'acacia-sapling', name: 'Acacia Sapling', stack: 64 },
        { id: 'dark-oak-sapling', name: 'Dark Oak Sapling', stack: 64 },
        { id: 'mangrove-propagule', name: 'Mangrove Propagule', stack: 64 },
        { id: 'mangrove-roots', name: 'Mangrove Roots', stack: 64 },
        { id: 'cherry-sapling', name: 'Cherry Sapling', stack: 64 },
        { id: 'lily-pad', name: 'Lily Pad', stack: 64 },
        { id: 'dead-bush', name: 'Dead Bush', stack: 64 },
        { id: 'fern', name: 'Fern', stack: 64 },
        { id: 'tall-grass', name: 'Tall Grass', stack: 64 },
        { id: 'large-fern', name: 'Large Fern', stack: 64 },
        { id: 'seagrass', name: 'Seagrass', stack: 64 },
        { id: 'kelp', name: 'Kelp', stack: 64 },
        { id: 'creaking-heart', name: 'Creaking Heart', stack: 64 },
        { id: 'pale-moss-block', name: 'Pale Moss Block', stack: 64 },
        { id: 'pale-moss-carpet', name: 'Pale Moss Carpet', stack: 64 },
        { id: 'pale-hanging-moss', name: 'Pale Hanging Moss', stack: 64 },
        { id: 'open-eyeblossom', name: 'Open Eyeblossom', stack: 64 },
        { id: 'closed-eyeblossom', name: 'Closed Eyeblossom', stack: 64 },
        { id: 'bush', name: 'Bush', stack: 64 },
        { id: 'cactus-flower', name: 'Cactus Flower', stack: 64 },
        { id: 'firefly-bush', name: 'Firefly Bush', stack: 64 },
        { id: 'leaf-litter', name: 'Leaf Litter', stack: 64 },
        { id: 'wildflowers', name: 'Wildflowers', stack: 64 },
        { id: 'short-dry-grass', name: 'Short Dry Grass', stack: 64 },
        { id: 'tall-dry-grass', name: 'Tall Dry Grass', stack: 64 }
      ],


      coral: [        
        { id: 'tube-coral-block', name: 'Tube Coral Block', stack: 64 },
        { id: 'brain-coral-block', name: 'Brain Coral Block', stack: 64 },
        { id: 'bubble-coral-block', name: 'Bubble Coral Block', stack: 64 },
        { id: 'fire-coral-block', name: 'Fire Coral Block', stack: 64 },
        { id: 'horn-coral-block', name: 'Horn Coral Block', stack: 64 },
        { id: 'dead-tube-coral-block', name: 'Dead Tube Coral Block', stack: 64 },
        { id: 'dead-brain-coral-block', name: 'Dead Brain Coral Block', stack: 64 },
        { id: 'dead-bubble-coral-block', name: 'Dead Bubble Coral Block', stack: 64 },
        { id: 'dead-fire-coral-block', name: 'Dead Fire Coral Block', stack: 64 },
        { id: 'dead-horn-coral-block', name: 'Dead Horn Coral Block', stack: 64 },
        { id: 'tube-coral', name: 'Tube Coral', stack: 64 },
        { id: 'brain-coral', name: 'Brain Coral', stack: 64 },
        { id: 'bubble-coral', name: 'Bubble Coral', stack: 64 },
        { id: 'fire-coral', name: 'Fire Coral', stack: 64 },
        { id: 'horn-coral', name: 'Horn Coral', stack: 64 },
        { id: 'tube-coral-fan', name: 'Tube Coral Fan', stack: 64 },
        { id: 'brain-coral-fan', name: 'Brain Coral Fan', stack: 64 },
        { id: 'bubble-coral-fan', name: 'Bubble Coral Fan', stack: 64 },
        { id: 'fire-coral-fan', name: 'Fire Coral Fan', stack: 64 },
        { id: 'horn-coral-fan', name: 'Horn Coral Fan', stack: 64 },
        { id: 'sponge', name: 'Sponge', stack: 64 },
        { id: 'wet-sponge', name: 'Wet Sponge', stack: 64 }
      ],

      ores_gems: [
        { id: 'coal-ore', name: 'Coal Ore', stack: 64 },
        { id: 'deepslate-coal-ore', name: 'Deepslate Coal Ore', stack: 64 },
        { id: 'coal', name: 'Coal', stack: 64 },
        { id: 'charcoal', name: 'Charcoal', stack: 64 },
        { id: 'block-of-coal', name: 'Block of Coal', stack: 64 },
        
        { id: 'copper-ore', name: 'Copper Ore', stack: 64 },
        { id: 'deepslate-copper-ore', name: 'Deepslate Copper Ore', stack: 64 },
        { id: 'raw-copper', name: 'Raw Copper', stack: 64 },
        { id: 'copper-ingot', name: 'Copper Ingot', stack: 64 },
        { id: 'copper-nugget', name: 'Copper Nugget', stack: 64 },
        { id: 'block-of-raw-copper', name: 'Block of Raw Copper', stack: 64 },
        
        { id: 'iron-ore', name: 'Iron Ore', stack: 64 },
        { id: 'deepslate-iron-ore', name: 'Deepslate Iron Ore', stack: 64 },
        { id: 'raw-iron', name: 'Raw Iron', stack: 64 },
        { id: 'iron-ingot', name: 'Iron Ingot', stack: 64 },
        { id: 'iron-nugget', name: 'Iron Nugget', stack: 64 },
        { id: 'block-of-raw-iron', name: 'Block of Raw Iron', stack: 64 },
        { id: 'block-of-iron', name: 'Block of Iron', stack: 64 },
        
        { id: 'gold-ore', name: 'Gold Ore', stack: 64 },
        { id: 'deepslate-gold-ore', name: 'Deepslate Gold Ore', stack: 64 },
        { id: 'nether-gold-ore', name: 'Nether Gold Ore', stack: 64 },
        { id: 'raw-gold', name: 'Raw Gold', stack: 64 },
        { id: 'gold-ingot', name: 'Gold Ingot', stack: 64 },
        { id: 'gold-nugget', name: 'Gold Nugget', stack: 64 },
        { id: 'block-of-raw-gold', name: 'Block of Raw Gold', stack: 64 },
        { id: 'block-of-gold', name: 'Block of Gold', stack: 64 },
        
        { id: 'redstone-ore', name: 'Redstone Ore', stack: 64 },
        { id: 'deepslate-redstone-ore', name: 'Deepslate Redstone Ore', stack: 64 },
        { id: 'redstone', name: 'Redstone Dust', stack: 64 },
        { id: 'block-of-redstone', name: 'Block of Redstone', stack: 64 },
        
        { id: 'lapis-lazuli-ore', name: 'Lapis Lazuli Ore', stack: 64 },
        { id: 'deepslate-lapis-lazuli-ore', name: 'Deepslate Lapis Lazuli Ore', stack: 64 },
        { id: 'lapis-lazuli', name: 'Lapis Lazuli', stack: 64 },
        { id: 'block-of-lapis-lazuli', name: 'Block of Lapis Lazuli', stack: 64 },
        
        { id: 'diamond-ore', name: 'Diamond Ore', stack: 64 },
        { id: 'deepslate-diamond-ore', name: 'Deepslate Diamond Ore', stack: 64 },
        { id: 'diamond', name: 'Diamond', stack: 64 },
        { id: 'block-of-diamond', name: 'Block of Diamond', stack: 64 },
        
        { id: 'emerald-ore', name: 'Emerald Ore', stack: 64 },
        { id: 'deepslate-emerald-ore', name: 'Deepslate Emerald Ore', stack: 64 },
        { id: 'emerald', name: 'Emerald', stack: 64 },
        { id: 'block-of-emerald', name: 'Block of Emerald', stack: 64 },
        
        { id: 'nether-quartz-ore', name: 'Nether Quartz Ore', stack: 64 },
        { id: 'nether-quartz', name: 'Nether Quartz', stack: 64 },
        { id: 'block-of-quartz', name: 'Block of Quartz', stack: 64 },
        
        { id: 'amethyst-shard', name: 'Amethyst Shard', stack: 64 },
        { id: 'block-of-amethyst', name: 'Block of Amethyst', stack: 64 },
        
        { id: 'ancient-debris', name: 'Ancient Debris', stack: 64 },
        { id: 'netherite-scrap', name: 'Netherite Scrap', stack: 64 },
        { id: 'netherite-ingot', name: 'Netherite Ingot', stack: 64 },
        { id: 'block-of-netherite', name: 'Block of Netherite', stack: 64 }
      ],

misc: [
  // === ESSENTIAL UTILITIES (High Traffic) ===
  { id: 'beacon', name: 'Beacon', stack: 64 },
  { id: 'stick', name: 'Stick', stack: 64 },
  { id: 'lead', name: 'Lead', stack: 64 },
  { id: 'name-tag', name: 'Name Tag', stack: 64 },
  { id: 'ladder', name: 'Ladder', stack: 64 },
  { id: 'scaffolding', name: 'Scaffolding', stack: 64 },
  { id: 'saddle', name: 'Saddle', stack: 1 },
  { id: 'bucket', name: 'Bucket', stack: 16 },
  { id: 'water-bucket', name: 'Water Bucket', stack: 1 },
  { id: 'lava-bucket', name: 'Lava Bucket', stack: 1 },
  { id: 'milk-bucket', name: 'Milk Bucket', stack: 1 },
  { id: 'powder-snow-bucket', name: 'Powder Snow Bucket', stack: 1 },
  { id: 'ender-pearl', name: 'Ender Pearl', stack: 16 },
  { id: 'eye-of-ender', name: 'Eye of Ender', stack: 64 },
  { id: 'totem-of-undying', name: 'Totem of Undying', stack: 1 },
  { id: 'end-crystal', name: 'End Crystal', stack: 64 },
  { id: 'ominous-bottle-1', name: 'Ominous Bottle I', stack: 64 },
  { id: 'ominous-bottle-2', name: 'Ominous Bottle II', stack: 64 },
  { id: 'ominous-bottle-3', name: 'Ominous Bottle III', stack: 64 },
  { id: 'ominous-bottle-4', name: 'Ominous Bottle IV', stack: 64 },
  { id: 'ominous-bottle-5', name: 'Ominous Bottle V', stack: 64 },
  { id: 'ghast-tear', name: 'Ghast Tear', stack: 64 },
  { id: 'compass', name: 'Compass', stack: 1 },
  { id: 'recovery-compass', name: 'Recovery Compass', stack: 1 },
  { id: 'firework-rocket', name: 'Firework Rocket (Flight)', stack: 64 },
  { id: 'echo-shard', name: 'Echo Shard', stack: 64 },
  { id: 'decorated-pot', name: 'Decorated Pot', stack: 64 },

  // === DISPLAY & DECOR (Functional) ===
  { id: 'item-frame', name: 'Item Frame', stack: 64 },
  { id: 'glow-item-frame', name: 'Glow Item Frame', stack: 64 },
  { id: 'painting', name: 'Painting', stack: 64 },
  { id: 'iron-bars', name: 'Iron Bars', stack: 64 },
  { id: 'iron-chain', name: 'Iron Chain', stack: 64 },
  { id: 'lightning-rod', name: 'Lightning Rod', stack: 64 },

  // === COMBAT & ADVENTURE (1.21 Keys/Drops) ===
  { id: 'trial-key', name: 'Trial Key', stack: 64 },
  { id: 'ominous-trial-key', name: 'Ominous Trial Key', stack: 64 },
  { id: 'wind-charge', name: 'Wind Charge', stack: 64 },
  { id: 'breeze-rod', name: 'Breeze Rod', stack: 64 },
  { id: 'heavy-core', name: 'Heavy Core', stack: 64 },

  // === CRAFTING & NATURAL MATERIALS ===  
  { id: 'string', name: 'String', stack: 64 },
  { id: 'flint', name: 'Flint', stack: 64 },
  { id: 'slime-ball', name: 'Slime Ball', stack: 64 },
  { id: 'gunpowder', name: 'Gunpowder', stack: 64 },
  { id: 'blaze-rod', name: 'Blaze Rod', stack: 64 },
  { id: 'honeycomb', name: 'Honeycomb', stack: 64 },
  { id: 'honey-bottle', name: 'Honey Bottle', stack: 16 },
  { id: 'resin-clump', name: 'Resin Clump', stack: 64 },
  { id: 'bone-block', name: 'Bone Block', stack: 64 },
  { id: 'dried-kelp-block', name: 'Dried Kelp Block', stack: 64 },
  { id: 'vines', name: 'Vines', stack: 64 },
  


  // === EGGS ===
  { id: 'egg', name: 'Egg', stack: 16 },
  { id: 'blue-egg', name: 'Blue Egg', stack: 16 },
  { id: 'brown-egg', name: 'Brown Egg', stack: 16 },

  // === AQUATIC BUCKETS ===
  { id: 'bucket-of-tadpole', name: 'Bucket of Tadpole', stack: 1 },
  { id: 'bucket-of-axolotl', name: 'Bucket of Axolotl', stack: 1 },
  { id: 'bucket-of-cod', name: 'Bucket of Cod', stack: 1 },
  { id: 'bucket-of-salmon', name: 'Bucket of Salmon', stack: 1 },
  { id: 'bucket-of-tropical-fish', name: 'Bucket of Tropical Fish', stack: 1 },
  { id: 'bucket-of-pufferfish', name: 'Bucket of Pufferfish', stack: 1 }

  // === STATUES (Low Value/Collector Items) ===
  // { id: 'copper-golem-statue', name: 'Copper Golem Statue', stack: 64 },
  // { id: 'exposed-copper-golem-statue', name: 'Exposed Copper Golem Statue', stack: 64 },
  // { id: 'weathered-copper-golem-statue', name: 'Weathered Copper Golem Statue', stack: 64 },
  // { id: 'oxidized-copper-golem-statue', name: 'Oxidized Copper Golem Statue', stack: 64 },
  // { id: 'waxed-copper-golem-statue', name: 'Waxed Copper Golem Statue', stack: 64 },
  // { id: 'waxed-exposed-copper-golem-statue', name: 'Waxed Exposed Copper Golem Statue', stack: 64 },
  // { id: 'waxed-weathered-copper-golem-statue', name: 'Waxed Weathered Copper Golem Statue', stack: 64 },
  // { id: 'waxed-oxidized-copper-golem-statue', name: 'Waxed Oxidized Copper Golem Statue', stack: 64 }
],



    };


// Categories from minecraft creative inventory > goal: organize our categories (stone, decorative, ect.) into the respective Minecraft Categories so i can visually see how to reoganize my items lol 
// building_blocks: [/* stone, planks, stairs, slabs, doors, fences */],
// colored_blocks: [/* wool, concrete, terracotta, glass, candles */],
// natural_blocks: [/* dirt, grass, ores, logs, plants, coral */],
// functional: [/* chests, beds, workstations, banners */],
// redstone: [/* redstone, repeaters, comparators, rails */],
// tools_utilities: [/* all tools, shears, flint&steel */],
// combat: [/* armor, weapons, shields */],
// food_drinks: [/* food items */],
// ingredients: [/* gems, ingots, raw materials, dyes */]



// Category display names (Sorted by Minecraft Creative Inventory Tabs)
const categoryNames = {
  // === BUILDING BLOCKS ===
  stone: '⛏️ Stone Variants',
  decorative_stone: '✨ Decorative Stone',
  planks: '🌳 Planks',
  leaves: '🍃 Leaves',
  walls: '🧱 Walls',
  copper: '🟫 Copper & Variants',
  doors_trapdoors: '🚪 Doors & Trapdoors',
  fences_gates: '🚧 Fences & Gates',
  volcanic: '🧱 Volcanic',

  // === COLORED BLOCKS ===
  concrete: '🧱 Concrete',
  terracotta: '🏺 Terracotta',
  wool: '🧶 Wool',
  stained_glass: '🟦 Glass',

  // === NATURAL BLOCKS ===
  logs: '🌲 Logs',
  natural: '🌍 Natural Blocks',
  crops: '🌾 Crops & Plants',
  coral: '🐠 Coral & Ocean',
  nether: '🔥 Nether',

  // === FUNCTIONAL BLOCKS ===
  storage: '📦 Storage',
  beds: '🛏️ Beds',
  banners: '🏳️ Banners',
  functional: '⚙️ Workstations',
  glass_lighting: '💡 Lighting',
  dyes: '🎨 Dyes',
  bundles: '🎒 Bundles',

  // === REDSTONE BLOCKS ===
  redstone: '⚡ Redstone',
  buttons: '🔘 Buttons & Plates',
  pressure_plates: '⚡ Pressure Plates',

  // === TOOLS & UTILITIES ===
  tools: '⚒️ Tools & Weapons',
  signs_frames: '📜 Signs',
  misc: '🔧 Miscellaneous',

  // === COMBAT ===
  armor: '🛡️ Armor',

  // === FOOD & DRINKS ===
  food: '🍕 Food',

  // === INGREDIENTS ===
  ores_gems: '💎 Ores & Gems - <i>(Copper Block found in Copper Section above)</i>'
};



function createItemCard(item) {
  return `
    <div class="item-card" title="${item.name}">
      <div class="mc-icon ${item.id}"></div>
      <input type="number" 
             id="input-${item.id}" 
             data-stack="${item.stack}"
             data-name="${item.name}"
             min="0" 
             value="0"
             placeholder="0">
      <div class="item-results" id="results-${item.id}"></div>
    </div>
  `;
}

function initializeCalculator() {
  const container = document.querySelector('.resource-calculator');
  if (!container) {
    console.error('Calculator container not found!');
    return;
  }
  
  const header = container.querySelector('.calc-header');
  const summary = container.querySelector('.results-summary');
  container.innerHTML = '';
  if (header) container.appendChild(header);
  
  // ADD FILTER BAR
  const filterBar = document.createElement('div');
  filterBar.className = 'filter-bar';
  filterBar.innerHTML = `
    <div style="display: flex; gap: 1rem; align-items: center; margin-bottom: 1.5rem; flex-wrap: wrap;">
      <input type="text" 
             id="search-filter" 
             placeholder="🔍 Search items..." 
             style="flex: 1; min-width: 250px; padding: 0.75rem; background: #1a1a1a; border: 2px solid #3a3a3a; border-radius: 6px; color: #fff; font-size: 1.5rem;">
      <label style="display: flex; align-items: center; gap: 0.5rem; color: #fff; cursor: pointer; white-space: nowrap;">
        <input type="checkbox" id="show-only-entered" style="width: 18px; height: 18px; cursor: pointer;">
        <span>Show only items with values</span>
      </label>
    </div>
  `;
  container.appendChild(filterBar);

  // BUILD CATEGORIES
  for (const [category, categoryItems] of Object.entries(items)) {
    const section = document.createElement('div');
    section.className = 'category-section';
    section.dataset.category = category;
    section.innerHTML = `
      <h1 class="category-title category-toggle" data-category="${category}">
        ${categoryNames[category]}        
      </h1>
      <div class="items-grid category-content" id="${category}-grid" style="display: grid;"></div>
    `;
    container.appendChild(section);
    
    const grid = section.querySelector('.items-grid');
    categoryItems.forEach(item => {
      grid.innerHTML += createItemCard(item);
    });
  }
  
  if (summary) container.appendChild(summary);
  
  // EVENT LISTENERS
  document.querySelectorAll('input[type="number"]').forEach(input => {
    input.addEventListener('input', updateCalculations);
  });
  
  document.querySelectorAll('.category-toggle').forEach(toggle => {
    toggle.addEventListener('click', function() {
      const content = this.nextElementSibling;
      const icon = this.querySelector('.toggle-icon');
      if (content.style.display === 'none') {
        content.style.display = 'grid';
        icon.textContent = '▼';
      } else {
        content.style.display = 'none';
        icon.textContent = '▶';
      }
    });
  });
  
  // FILTER EVENT LISTENERS
  document.getElementById('search-filter').addEventListener('input', applyFilters);
  document.getElementById('show-only-entered').addEventListener('change', applyFilters);
  
  // IMPORT SCHEMATIC LISTENER
  const importBtn = document.getElementById('import-schematic-btn');
  if (importBtn) {
    importBtn.addEventListener('click', openImportModal);
  }

  // CREATE BASE MATERIALS SECTION
  createBaseMaterialsSection();
}

// FILTER FUNCTION
function applyFilters() {
  const searchTerm = document.getElementById('search-filter').value.toLowerCase();
  const showOnlyEntered = document.getElementById('show-only-entered').checked;
  
  document.querySelectorAll('.category-section').forEach(section => {
    const itemCards = section.querySelectorAll('.item-card');
    let visibleCount = 0;
    
    itemCards.forEach(card => {
      const itemName = card.title.toLowerCase();
      const input = card.querySelector('input[type="number"]');
      const hasValue = parseInt(input.value) > 0;
      
      const matchesSearch = !searchTerm || itemName.includes(searchTerm);
      const matchesEntered = !showOnlyEntered || hasValue;
      
      if (matchesSearch && matchesEntered) {
        card.style.display = 'flex';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });
    
    if (visibleCount === 0) {
      section.style.display = 'none';
    } else {
      section.style.display = 'block';
    }
  });
}

function updateCalculations(event) {
  const input = event.target;
  const itemId = input.id.replace('input-', '');
  const amount = parseInt(input.value) || 0;
  const stackSize = parseInt(input.dataset.stack);
  
  const stacks = Math.ceil(amount / stackSize);
  const shulkers = Math.ceil(stacks / 27);
  
  const resultsDiv = document.getElementById(`results-${itemId}`);
  if (resultsDiv && amount > 0) {
    resultsDiv.innerHTML = `<div>${stacks}stacks / ${shulkers}sh</div>`;
    resultsDiv.style.display = 'block';
  } else if (resultsDiv) {
    resultsDiv.style.display = 'none';
  }
  
  updateTotalSummary();
}

function updateTotalSummary() {
  let totalItems = 0;
  let totalStacks = 0;
  let categoryData = {};
  let selectedItems = {};
  
  document.querySelectorAll('input[type="number"]').forEach(input => {
    const amount = parseInt(input.value) || 0;
    const stackSize = parseInt(input.dataset.stack);
    const itemName = input.dataset.name;
    const itemId = input.id.replace('input-', '');
    
    totalItems += amount;
    totalStacks += Math.ceil(amount / stackSize);
    
        // NEW: Track selected items for sprite display
    if (amount > 0) {
      selectedItems[itemId] = {
        name: itemName,
        amount: amount,
        stack: stackSize
      };
    }

    if (amount === 0) return;
    
    let itemCategory = null;
    for (const [catKey, catItems] of Object.entries(items)) {
      if (catItems.some(item => item.id === itemId)) {
        itemCategory = catKey;
        break;
      }
    }
    
    if (!itemCategory) return;
    
    if (!categoryData[itemCategory]) {
      categoryData[itemCategory] = {
        name: categoryNames[itemCategory],
        items: [],
        totalStacks: 0
      };
    }
    
    const stacks = Math.ceil(amount / stackSize);
    const shulkers = Math.ceil(stacks / 27);
    const chests = Math.ceil(stacks / 54);
    
    categoryData[itemCategory].items.push({
      name: itemName,
      amount: amount,
      stacks: stacks,
      shulkers: shulkers,
      chests: chests
    });
    categoryData[itemCategory].totalStacks += stacks;
  });
  
  const totalShulkers = Math.ceil(totalStacks / 27);
  const totalChests = Math.ceil(totalStacks / 54);
  
  const totalItemsEl = document.getElementById('total-items');
  const totalStacksEl = document.getElementById('total-stacks');
  const totalShulkersEl = document.getElementById('total-shulkers');
  const totalChestsEl = document.getElementById('total-chests');
  
  if (totalItemsEl) totalItemsEl.textContent = totalItems.toLocaleString();
  if (totalStacksEl) totalStacksEl.textContent = totalStacks.toLocaleString();
  if (totalShulkersEl) totalShulkersEl.textContent = totalShulkers.toLocaleString();
  if (totalChestsEl) totalChestsEl.textContent = totalChests.toLocaleString();
  
  updateSelectedItemsDisplay(selectedItems);

   const breakdownContent = document.getElementById('breakdown-content');
  const wasExpanded = breakdownContent && breakdownContent.style.display === 'block';
  const expandedCategories = {};
  
  for (const catKey in categoryData) {
    const catContent = document.getElementById(`cat-${catKey}`);
    if (catContent) {
      expandedCategories[catKey] = catContent.style.display === 'block';
    }
  }
  
  // Update breakdown container directly
  const container = document.getElementById('category-breakdown-container');
  if (!container) return;
  
  if (Object.keys(categoryData).length === 0) {
    container.innerHTML = '';
    return;
  }
    let html = `
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.75rem;">
        <h3 style="color: #55ff55; margin: 0; cursor: pointer; font-size: 2rem;" onclick="toggleBreakdown()">
          📦 Detailed Breakdown <span id="breakdown-toggle" style="font-size: 1.5rem;">${wasExpanded ? '▼' : '▶'}</span>
        </h3>
        <button onclick="exportList()" style="background: #55ff55; color: #003300; border: none; padding: 0.5rem 1rem; border-radius: 4px; cursor: pointer; font-weight: bold; font-size: 1.5rem;">
          📥 Export Selected Materials List
        </button>
      </div>
    `;
    html += `<div id="breakdown-content" style="display: ${wasExpanded ? 'block' : 'none'}; max-height: 400px; overflow-y: auto; padding-right: 0.5rem;">`;
    
    const sortedCategories = Object.entries(categoryData).sort((a, b) => b[1].totalStacks - a[1].totalStacks);
    
      for (const [catKey, catData] of sortedCategories) {
        const isCatExpanded = expandedCategories[catKey] !== false;
        
        html += `
          <div style="margin-bottom: 0.75rem; background: rgba(0,0,0,0.2); padding: 0.5rem; border-radius: 4px; border-left: 3px solid #55ff55;">
            <h4 style="color: #77ff77; margin: 0 0 0.5rem 0; cursor: pointer; font-size: 1.5rem; display: flex; justify-content: space-between;" onclick="toggleCategory('${catKey}')">
              <span>${catData.name}</span>
              <span style="color: #55ff55; font-size: 1.3rem;">${catData.totalStacks}s <span id="toggle-${catKey}">${isCatExpanded ? '▼' : '▶'}</span></span>
            </h4>
            <div id="cat-${catKey}" style="display: ${isCatExpanded ? 'block' : 'none'}; padding-left: 0.5rem;">
        `;
        
        catData.items.sort((a, b) => b.amount - a.amount);
        
        for (const item of catData.items) {
          html += `
            <div style="color: #ccc; padding: 0.3rem 0; font-size: 1.5rem; display: grid; grid-template-columns: 1fr auto; gap: 1rem; align-items: center;">
              <span style="color: #ddd;">${item.name}</span>
              <div style="display: flex; gap: 0.75rem; font-size: 1.3rem;">
                <span><span style="color: #55ff55; font-weight: bold;">${item.amount.toLocaleString()}</span> items</span>
                <span style="color: #888;">|</span>
                <span>${item.stacks} <span style="color: #888;">stacks</span></span>
                <span style="color: #888;">|</span>
                <span>${item.shulkers} <span style="color: #888;">shulkers</span></span>
                <span style="color: #888;">|</span>
                <span>${item.chests} <span style="color: #888;">chests</span></span>
              </div>
            </div>
          `;
        }
        
        html += `
            </div>
          </div>
        `;
    }
    
    html += '</div>';
    container.innerHTML = html;
  }


function updateSelectedItemsDisplay(selectedItems) {
  const container = document.getElementById('selected-items-display');
  if (!container) return;
  
  if (Object.keys(selectedItems).length === 0) {
    container.innerHTML = '<p style="color: #888; text-align: center; padding: 1rem;">No items selected yet</p>';
    return;
  }
  
let html = '';
  for (const [itemId, data] of Object.entries(selectedItems)) {
    const stackSize = data.stack || 64;
    const totalItems = data.amount;
    const stacks = Math.ceil(totalItems / stackSize);
    const shulkers = (stacks / 27).toFixed(1);

    // --- OPTION 1 HELPER LOGIC (Upgraded for Millions) ---
    let displayAmount;

    if (totalItems >= 1000000) {
      // For 1,000,000+ -> 1.2M
      displayAmount = (totalItems / 1000000).toFixed(1) + 'M';
    } else if (totalItems >= 99999) {
      // For 10,000+ -> 12.5k (using 10k as the threshold keeps the grid cleaner)
      displayAmount = (totalItems / 1000).toFixed(1) + 'k';
    } else {
      // Standard format for smaller numbers (e.g., 9,500)
      displayAmount = totalItems.toLocaleString();
    }

    // Adjust font size based on string length (M and k labels take space)
    const fontSize = displayAmount.length > 5 ? '1.4rem' : '1.8rem';
    // -----------------------------------------------------
    html += `
      <div class="selected-item-card">
        <div class="mc-icon ${itemId}"></div>
        
        <div class="selected-item-quantity" style="font-size: ${fontSize} !important;">
          ${displayAmount}
        </div>
        
        <div class="selected-item-info">
          <div class="info-line"><span>${stacks}</span> <span style="color: #888; font-size: 0.8rem;">stack</span></div>
          <div class="info-line"><span>${shulkers}</span> <span style="color: #888; font-size: 0.8rem;">shlkr</span></div>
        </div>
      </div>
    `;
  }
  
  container.innerHTML = html;
}

function toggleBreakdown() {
  const content = document.getElementById('breakdown-content');
  const toggle = document.getElementById('breakdown-toggle');
  if (content && toggle) {
    if (content.style.display === 'none') {
      content.style.display = 'block';
      toggle.textContent = '▼';
    } else {
      content.style.display = 'none';
      toggle.textContent = '▶';
    }
  }
}

function toggleCategory(catKey) {
  const content = document.getElementById(`cat-${catKey}`);
  const toggle = document.getElementById(`toggle-${catKey}`);
  if (content && toggle) {
    if (content.style.display === 'none') {
      content.style.display = 'block';
      toggle.textContent = '▼';
    } else {
      content.style.display = 'none';
      toggle.textContent = '▶';
    }
  }
}

function exportList() {
  let categoryData = {};
  let totalItems = 0;
  let totalStacks = 0;
  
  document.querySelectorAll('input[type="number"]').forEach(input => {
    const amount = parseInt(input.value) || 0;
    if (amount === 0) return;
    
    const stackSize = parseInt(input.dataset.stack);
    const itemName = input.dataset.name;
    const itemId = input.id.replace('input-', '');
    
    totalItems += amount;
    totalStacks += Math.ceil(amount / stackSize);
    
    let itemCategory = null;
    for (const [catKey, catItems] of Object.entries(items)) {
      if (catItems.some(item => item.id === itemId)) {
        itemCategory = catKey;
        break;
      }
    }
    
    if (!itemCategory) return;
    
    if (!categoryData[itemCategory]) {
      categoryData[itemCategory] = {
        name: categoryNames[itemCategory],
        items: []
      };
    }
    
    const stacks = Math.ceil(amount / stackSize);
    const shulkers = Math.ceil(stacks / 27);
    const chests = Math.ceil(stacks / 54);
    
    categoryData[itemCategory].items.push({
      name: itemName,
      amount: amount,
      stacks: stacks,
      shulkers: shulkers,
      chests: chests
    });
  });
  
  if (Object.keys(categoryData).length === 0) {
    alert('No items to export! Add some materials first.');
    return;
  }
  
const totalShulkers = Math.ceil(totalStacks / 27);
const totalChests = Math.ceil(totalStacks / 54);

let exportText = 'RESOURCE CALCULATOR MATERIALS LIST\n';
exportText += '==============================================\n\n';
exportText += `Total Items: ${totalItems.toLocaleString()}\n`;
exportText += `Total Stacks: ${totalStacks.toLocaleString()}\n`;
exportText += `Total Shulker Boxes: ${totalShulkers.toLocaleString()}\n`;
exportText += `Total Double Chests: ${totalChests.toLocaleString()}\n\n`;
exportText += '\n';

const sortedCategories = Object.entries(categoryData).sort((a, b) => {
  const totalA = a[1].items.reduce((sum, item) => sum + item.stacks, 0);
  const totalB = b[1].items.reduce((sum, item) => sum + item.stacks, 0);
  return totalB - totalA;
});

for (const [catKey, catData] of sortedCategories) {
  exportText += `${catData.name}\n`;
  exportText += '----------------------------------------------\n';
  
  catData.items.sort((a, b) => b.amount - a.amount);
  
for (const item of catData.items) {
  // Find the actual stack size from items database
  let stackSize = 64; // default
  
  for (const category of Object.values(items)) {
    const foundItem = category.find(i => i.name === item.name);
    if (foundItem) {
      stackSize = foundItem.stack;
      break;
    }
  }
  
  const fullStacks = Math.floor(item.amount / stackSize);
  const remainder = item.amount % stackSize;
  
  // Only show stack breakdown if MORE than 1 stack needed
  let stackBreakdown = '';
  if (fullStacks > 0) {
    stackBreakdown = `  [${stackSize}x${fullStacks}`;
    if (remainder > 0) {
      stackBreakdown += ` + ${remainder}]`;
    }
  }
  
  exportText += `${item.amount}x ${item.name}${stackBreakdown}\n`;
}
  
  exportText += '\n';
}

exportText += '==============================================\n';
exportText += `Generated: ${new Date().toLocaleString()}\n`;

const blob = new Blob([exportText], { type: 'text/plain' });
const url = URL.createObjectURL(blob);
const a = document.createElement('a');
a.href = url;
a.download = `materials-list-${Date.now()}.txt`;
a.click();
URL.revokeObjectURL(url);
}

// ==========================================
// PHASE 2: BASE MATERIALS CALCULATOR ENGINE
// ==========================================

// --- INITIALIZE NAME MAPPER ---
let itemNameMap = {};

function buildItemLookupMap() {
    itemNameMap = {};
    for (const category of Object.values(items)) {
        category.forEach(item => {
            // Converts "Slime Ball" to "slime-ball"
            const normalized = item.name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
            itemNameMap[normalized] = item.id;
        });
    }
}

// --- STEP 2: MODAL & PARSER ---
function openImportModal() {
    if (Object.keys(itemNameMap).length === 0) buildItemLookupMap();

    const modalHtml = `
    <div id="import-modal" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.9); display: flex; align-items: center; justify-content: center; z-index: 10000; font-family: sans-serif;">
      <div style="background: #222; padding: 2rem; border-radius: 12px; width: 95%; max-width: 700px; border: 2px solid #3498db; box-shadow: 0 0 20px rgba(52, 152, 219, 0.3);">
        
        <h2 style="color: #3498db; margin: 0 0 1rem 0;">📂 Import Materials</h2>
        
        <!-- INSTRUCTIONS BOX -->
        <div style="background: rgba(52, 152, 219, 0.1); border-left: 3px solid #3498db; padding: 1rem; margin-bottom: 1.5rem; border-radius: 4px;">
          <div style="color: #3498db; font-weight: bold; margin-bottom: 0.5rem;">📋 How to Import:</div>
          <div style="color: #aaa; font-size: 1.2rem; line-height: 1.6;">
            <strong style="color: #fff;">Option 1 - Litematica Schematic:</strong><br>
            1. Open schematic in Litematica (in-game)<br>
            2. Press <code style="background: #111; padding: 2px 6px; border-radius: 3px; color: #55ff55;">M</code> key → Material List<br>
            3. Save to file or copy the table<br>
            4. Paste below<br><br>
            
            <strong style="color: #fff;">Option 2 - Manual Entry:</strong><br>
            Type items like: <code style="background: #111; padding: 2px 6px; border-radius: 3px; color: #55ff55;">oak planks x 64</code> or <code style="background: #111; padding: 2px 6px; border-radius: 3px; color: #55ff55;">64 oak planks</code>
          </div>
        </div>
        
        <textarea id="schematic-paste-area" placeholder="Paste Litematica materials list or type manually (e.g., 'oak planks x 64')..." 
            style="width: 100%; height: 250px; background: #111; color: #fff; border: 1px solid #444; padding: 12px; border-radius: 6px; font-family: monospace; font-size: 1.2rem;"></textarea>
        
        <div style="display: flex; gap: 1rem; margin-top: 1.5rem;">
          <button onclick="processSchematicImport()" style="flex: 2; padding: 1.2rem; background: #3498db; color: #fff; border: none; border-radius: 6px; font-weight: bold; cursor: pointer; font-size: 1.4rem;">Import & Populate</button>
          <button onclick="document.getElementById('import-modal').remove()" style="flex: 1; padding: 1.2rem; background: #444; color: #fff; border: none; border-radius: 6px; cursor: pointer; font-size: 1.4rem;">Cancel</button>
        </div>
      </div>
    </div>`;
    document.body.insertAdjacentHTML('beforeend', modalHtml);
}

function processSchematicImport() {
    const text = document.getElementById('schematic-paste-area').value;
    if (!text) return;

    const lines = text.split('\n');
    let matched = 0;
    let unmatched = [];
    
    lines.forEach(line => {
        line = line.trim();
        if (!line) return;
        
        let itemName = null;
        let quantity = null;
        
        // FORMAT 1: Table format with pipes | Item Name | 1234 | 0 | 0 |
        if (line.includes('|')) {
            // Skip header/separator lines
            if (line.includes('+---') || 
                line.includes('Material List') || 
                line.includes('| Item ') ||
                line.includes('Missing')) {
                return;
            }
            
            const parts = line.split('|').map(p => p.trim()).filter(p => p);
            if (parts.length >= 2) {
                itemName = parts[0];
                quantity = parseInt(parts[1].replace(/,/g, ''));
            }
        } 
        // FORMAT 2: Simple format - "lead x3" or "3 lead" or "lead: 3"
        else {
            // Try: "Item Name x 123"
            let match = line.match(/^(.+?)\s*x\s*([0-9,]+)/i);
            
            // Try: "123 Item Name"
            if (!match) {
                match = line.match(/^([0-9,]+)\s+(.+)/);
                if (match) {
                    itemName = match[2];
                    quantity = parseInt(match[1].replace(/,/g, ''));
                }
            } else {
                itemName = match[1];
                quantity = parseInt(match[2].replace(/,/g, ''));
            }
            
            // Try: "Item Name: 123"
            if (!match) {
                match = line.match(/^(.+?):\s*([0-9,]+)/);
                if (match) {
                    itemName = match[1];
                    quantity = parseInt(match[2].replace(/,/g, ''));
                }
            }
        }
        
        // Skip if we couldn't parse or quantity is invalid
        if (!itemName || isNaN(quantity) || quantity === 0) return;
        
        // Normalize and match
        const normalized = itemName.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
        const itemId = itemNameMap[normalized];

        if (itemId) {
            const input = document.getElementById(`input-${itemId}`);
            if (input) {
                input.value = (parseInt(input.value) || 0) + quantity;
                updateCalculations({ target: input });
                matched++;
            }
        } else {
            unmatched.push(itemName);
        }
    });
    
    // Show results
    if (unmatched.length > 0) {
        console.log('⚠️ Could not match:', unmatched);
        alert(`✅ Imported ${matched} items successfully!\n⚠️ Could not match ${unmatched.length} items:\n${unmatched.slice(0, 5).join(', ')}${unmatched.length > 5 ? '...' : ''}`);
    } else {
        alert(`✅ Successfully imported ${matched} items!`);
    }
    
    document.getElementById('import-modal').remove();
    
    // Auto-trigger calculation
    setTimeout(() => {
        calculateAllBaseMaterials();
    }, 100);
}

function calculateBaseMaterialsWithSurplus(itemId, quantity, useOptimized = true, surplus = {}) {
  const breakdown = {};
  const craftingSteps = [];
  
  function recurse(id, qty, depth = 0) {
    if (qty <= 0) return;
    
    // Check surplus first!
    if (surplus[id] > 0) {
      const taken = Math.min(surplus[id], qty);
      qty -= taken;
      surplus[id] -= taken;
    }
    
    if (qty <= 0) return;
    
    const recipe = craftingRecipes[id];
    
    if (!recipe || recipe.isBaseResource) {
      breakdown[id] = (breakdown[id] || 0) + qty;
      return;
    }
    
    const selectedRecipe = selectRecipe(recipe.recipes, useOptimized);
    if (!selectedRecipe) {
      breakdown[id] = (breakdown[id] || 0) + qty;
      return;
    }
    
    const craftsNeeded = Math.ceil(qty / selectedRecipe.output);
    const totalProduced = craftsNeeded * selectedRecipe.output;
    
    // Store surplus!
    const extra = totalProduced - qty;
    if (extra > 0) {
      surplus[id] = (surplus[id] || 0) + extra;
    }
    
    craftingSteps.push({
      depth: depth,
      method: selectedRecipe.method,
      output: { id: id, amount: totalProduced, name: recipe.name },
      inputs: selectedRecipe.ingredients.map(ing => {
        const resolvedId = ing.tag ? resolveTag(ing.tag) : ing.id;
        const resolvedRecipe = craftingRecipes[resolvedId];
        return {
          id: resolvedId,
          amount: ing.amount * craftsNeeded,
          name: resolvedRecipe ? resolvedRecipe.name : resolvedId
        };
      }),
      craftsNeeded: craftsNeeded
    });
    
    for (const ingredient of selectedRecipe.ingredients) {
      const ingredientQty = ingredient.amount * craftsNeeded;
      const resolvedId = ingredient.tag ? resolveTag(ingredient.tag) : ingredient.id;
      recurse(resolvedId, ingredientQty, depth + 1);
    }
  }
  
  recurse(itemId, quantity);
  
  return {
    baseMaterials: breakdown,
    craftingSteps: craftingSteps.reverse()
  };
}

function selectRecipe(recipes, useOptimized) {
  if (!recipes || recipes.length === 0) return null;
  
  if (useOptimized) {
    const priority = recipes.find(r => r.priority);
    if (priority) return priority;
  }
  
  return recipes[0];
}

function resolveTag(tagName) {
  const tagItems = materialTags[tagName];
  return tagItems ? tagItems[0] : null;
}

function toggleBaseMaterials() {
  const content = document.getElementById('base-materials-content');
  const toggle = document.getElementById('base-materials-toggle');
  if (content && toggle) {
    if (content.style.display === 'none') {
      content.style.display = 'block';
      toggle.textContent = '▼';
    } else {
      content.style.display = 'none';
      toggle.textContent = '▶';
    }
  }
}


function displayBaseMaterials(breakdown) {
  const container = document.getElementById('base-materials-result');
  if (!container) return;
  
  const materials = Object.entries(breakdown)
    .filter(([id, qty]) => qty > 0)
    .sort((a, b) => b[1] - a[1]);
  
  if (materials.length === 0) {
    container.innerHTML = '<p style="color: #888;">No materials needed or all items are already base resources.</p>';
    return;
  }
  
  // COLLAPSIBLE HEADER
  container.innerHTML = `
    <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 1rem; cursor: pointer; padding: 0.5rem; background: rgba(85, 255, 85, 0.1); border-radius: 6px;" onclick="toggleBaseMaterials()">
      <h4 style="color: #55ff55; margin: 0;">📦 Base Materials Needed (${materials.length} items)</h4>
      <span id="base-materials-toggle" style="color: #55ff55; font-size: 1.5rem;">▼</span>
    </div>
    <div id="base-materials-content" style="display: block;">
  `;
  
  let html = '<div style="display: grid; gap: 0.5rem; margin-top: 0.75rem;">';
  
  for (const [itemId, quantity] of materials) {
    let itemData = null;
    for (const category of Object.values(items)) {
      itemData = category.find(item => item.id === itemId);
      if (itemData) break;
    }
    
    const itemName = itemData ? itemData.name : itemId;
    const stackSize = itemData ? itemData.stack : 64;
    const stacks = Math.floor(quantity / stackSize);
    const remainder = quantity % stackSize;
    const shulkers = Math.ceil(Math.ceil(quantity / stackSize) / 27);
    
    html += `
      <div style="display: grid; grid-template-columns: auto 1fr auto; gap: 1rem; align-items: center; background: rgba(0,0,0,0.3); padding: 0.5rem; border-radius: 4px;">
        <div class="mc-icon ${itemId}" style="width: 37px; height: 36px;"></div>
        <span style="color: #ddd;">${itemName}</span>
        <div style="display: flex; gap: 0.75rem; font-size: 1.5rem; color: #aaa;">
          <span><strong style="color: #55ff55;">${quantity.toLocaleString()}</strong> items</span>
          <span>|</span>
          <span>${stacks} <span style="color: #888; font-size: 1.2rem;">stacks</span> ${remainder} <span style="color: #888;font-size: 1.2rem;">items</span></span>
          <span>|</span>
          <span>${shulkers} <span style="color: #888;font-size: 1.2rem;">shulkers</span></span>
        </div>
      </div>
    `;
  }
  
  html += '</div></div>';
  container.innerHTML += html;
}


function displayCraftingSteps(steps) {
  const container = document.getElementById('crafting-steps-result');
  if (!container) return;
  
  if (steps.length === 0) {
    container.innerHTML = '';
    return;
  }
  
  // Consolidate duplicate steps
  const consolidatedSteps = new Map();
  
  steps.forEach(step => {
    const key = `${step.output.id}-${step.method}`;
    
    if (consolidatedSteps.has(key)) {
      const existing = consolidatedSteps.get(key);
      existing.output.amount += step.output.amount;
      existing.craftsNeeded += step.craftsNeeded;
      existing.inputs.forEach((inp, i) => {
        inp.amount += step.inputs[i].amount;
      });
    } else {
      consolidatedSteps.set(key, {
        ...step,
        output: { ...step.output },
        inputs: step.inputs.map(inp => ({ ...inp })),
        craftsNeeded: step.craftsNeeded
      });
    }
  });
  
  const consolidatedArray = Array.from(consolidatedSteps.values());
  
// Group steps into intermediate and final
  const intermediateSteps = [];
  const finalSteps = [];
  
  consolidatedArray.forEach(step => {
    const isIntermediate = consolidatedArray.some(s => 
      s.inputs.some(inp => inp.id === step.output.id)
    );
    
    if (isIntermediate) {
      intermediateSteps.push(step);
    } else {
      finalSteps.push(step);
    }
  });

  // NEW: Sort Intermediate Steps by Depth (Deepest first)
  // This ensures "Logs -> Planks" always appears before "Planks -> Sticks"
  intermediateSteps.sort((a, b) => b.depth - a.depth); 

  container.innerHTML = `
    <div style="display: flex; align-items: center; margin-top: 3.5rem;">
      <h4 style="color: #55ff55; margin: 0;">📋 Quick Craft Guide</h4>
      <span style="color: #888; font-size: 1.2rem; font-style: italic; margin-left: 0.5rem; margin-right: 0.5rem;">[Beta v4.2]</span>
      <span style="color:rgba(255, 255, 255, 0.56); font-size: 1.1rem;"> 💡 Tip: Craft items starting from base materials (logs, ores) before intermediate items (planks, ingots).
      </span>
    </div>
  
  `;

  let html = '<div style="display: grid; gap: 1rem; margin-top: 0.75rem;">';
  
  // Intermediate crafts section
  if (intermediateSteps.length > 0) {
    
    html += `
      <div style="background: rgba(0,0,0,0.3); padding: 1rem; border-radius: 6px; border-left: 3px solid #ff9955;">
        <div style="color: #ff9955; font-weight: bold; font-size: 1.6rem; margin-bottom: 0.75rem;">
           Crafting and Smelting Steps
        </div>
    `;
    
intermediateSteps.forEach(step => {
  const inputsHtml = step.inputs.map(inp => 
    `<span style="display: inline-flex; align-items: center; gap: 4px; background: rgba(0,0,0,0.2); padding: 2px 6px; border-radius: 4px;">
      <div class="mc-icon ${inp.id}" style="width: 36px; height: 36px; transform: scale(1);"></div>
      ${inp.amount}
    </span>`
  ).join(' + ');

  const craftsText = step.craftsNeeded > 1 ? `<span style="color: #888; font-size: 1rem; margin-left: 10px;">[${step.craftsNeeded} Crafts]</span>` : '';

  html += `
    <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 0.8rem; padding: 0.5rem; background: rgba(255,255,255,0.03); border-radius: 4px;">
      <div style="min-width: 120px; font-size: 1.1rem;">${inputsHtml}</div>
      <span style="color: #888;">→</span>
      <div class="mc-icon ${step.output.id}" style="width: 36px; height: 36px;"></div>
      <strong style="color: #ff9955; font-size: 1.3rem;">${step.output.amount} ${step.output.name}</strong>
      ${craftsText}
    </div>
  `;
});
    
    html += '</div>';
  }
  
  // Final items section

 if (finalSteps.length > 0) {
    html += `
      <div style="background: rgba(0,0,0,0.3); padding: 1rem; border-radius: 6px; border-left: 3px solid #55ff55;">
        <div style="color: #55ff55; font-weight: bold; font-size: 1.6rem; margin-bottom: 0.75rem; margin-top: 0.75rem;">
          ⚔️ Craft Your Items (${finalSteps.length})
        </div>
    `;
    
    finalSteps.forEach(step => {
      // Create the ingredient string first
      const inputText = step.inputs.map(inp => `${inp.amount} ${inp.name}`).join(' + ');
      
      html += `
        <div style="color: #ddd; font-size: 1.4rem; margin-bottom: 0.5rem; padding-left: 1rem;">
          ✓ <span style="color:rgb(138, 138, 138);">Take</span> <strong style="color: #ff9955;">${inputText}</strong> <span style="color:rgb(138, 138, 138);">& craft</span> <strong style="color: #55ff55;">${step.output.name}</strong>
        </div>
      `; 
    });
    
    html += '</div>';
  }
  
  html += '</div>';
  container.innerHTML += html;
}

function displaySurplus(surplus) {
  const container = document.getElementById('crafting-steps-result');
  const extras = Object.entries(surplus).filter(([id, qty]) => qty > 0);
  
  if (extras.length === 0) return;

  let html = `
    <div style="margin-top: 1.5rem; border-top: 1px dashed #444; padding-top: 1rem;">
      <h4 style="color: #aaa; font-size: 1.2rem;">✨ Leftover Items (Surplus):</h4>
      <div style="display: flex; gap: 1rem; flex-wrap: wrap; margin-top: 0.5rem;">
  `;

  for (const [id, qty] of extras) {
    html += `
      <div style="background: rgba(255,255,255,0.05); padding: 4px 8px; border-radius: 4px; display: flex; align-items: center; gap: 6px; color: #888;">
        <div class="mc-icon ${id}" style="width: 36px; height: 36px; transform: scale(0.5);"></div>
        <span>${qty} ${id.replace(/-/g, ' ')}</span>
      </div>
    `;
  }

  html += '</div></div>';
  container.innerHTML += html;
}

function calculateAllBaseMaterials() {
  const useOptimized = document.getElementById('use-optimized').checked;
  const allBreakdown = {};
  const allSteps = [];
  const sharedSurplus = {}; // SHARED across all items!
  
  document.querySelectorAll('input[type="number"]').forEach(input => {
    const quantity = parseInt(input.value) || 0;
    if (quantity > 0) {
      const itemId = input.id.replace('input-', '');
      
      if (typeof craftingRecipes === 'undefined' || !craftingRecipes[itemId]) {
        console.log(`No recipe found for: ${itemId}`);
        return;
      }
      
      // Pass shared surplus to each calculation
      const result = calculateBaseMaterialsWithSurplus(itemId, quantity, useOptimized, sharedSurplus);
      
      for (const [id, qty] of Object.entries(result.baseMaterials)) {
        allBreakdown[id] = (allBreakdown[id] || 0) + qty;
      }
      
      allSteps.push(...result.craftingSteps);
    }
  });
  
  displayBaseMaterials(allBreakdown);
  displayCraftingSteps(allSteps);

  displaySurplus(sharedSurplus);
const copyBtn = document.getElementById('copy-list-btn');
    if (copyBtn) {
        copyBtn.style.display = 'block';
        // Remove old listener if it exists to prevent double-firing
        const newBtn = copyBtn.cloneNode(true);
        copyBtn.parentNode.replaceChild(newBtn, copyBtn);
        
        newBtn.addEventListener('click', () => {
            copyShoppingList(allBreakdown, allSteps);            
        });
    }
      // SHOW AND SET UP DOWNLOAD BUTTON
  const downloadBtn = document.getElementById('download-list-btn');
  if (downloadBtn) {
    downloadBtn.style.display = 'block';
    const newDownloadBtn = downloadBtn.cloneNode(true);
    downloadBtn.parentNode.replaceChild(newDownloadBtn, downloadBtn);
    
    newDownloadBtn.addEventListener('click', () => {
      downloadShoppingList(allBreakdown, allSteps);
    });
  }
}

function createBaseMaterialsSection() {
    const container = document.getElementById('base-materials-container');
    if (!container) return;

    // Use a conditional check to prevent re-injecting if it already exists
    if (document.getElementById('calculate-base-materials')) return;

container.innerHTML = `
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
        <h3 style="color: #55ff55; margin: 0;">🔧 Base Materials Calculator</h3>
        <label style="display: flex; align-items: center; gap: 0.5rem; color: #fff; cursor: pointer;">
            <input type="checkbox" id="use-optimized" checked style="width: 18px; height: 18px;">
            <span>Use optimized recipes</span>
        </label>
    </div>
    
    <div style="display: flex; gap: 10px; margin-bottom: 10px;">
        <button id="calculate-base-materials" style="flex: 4; padding: 1rem; background: #ffffff; color: #003300; border: none; border-radius: 6px; font-weight: bold; font-size: 1.4rem; cursor: pointer;">
            Calculate Base Materials
        </button>
        <button id="copy-list-btn" style="flex: 1; padding: 1rem; background: #55ff55; color: #003300; border: none; border-radius: 6px; font-weight: bold; cursor: pointer; display: none;">
            📋 Copy Base
        </button>
        <button id="download-list-btn" style="flex: 1; padding: 1rem; background: rgb(85, 215, 255); color: #003300; border: none; border-radius: 6px; font-weight: bold; cursor: pointer; display: none;">
            📥 Dwnld Base (.txt)
        </button>
    </div>

    <div id="base-materials-result"></div>
    <div id="crafting-steps-result"></div>
    
`;
  
    // Listener for Calculate button
    document.getElementById('calculate-base-materials').addEventListener('click', calculateAllBaseMaterials);
}

function downloadShoppingList(breakdown, steps) {
    let text = "==============================================\n";
    text += "   MINECRAFT BASE MATERIALS SHOPPING LIST\n";
    text += "==============================================\n\n";
    
    // Track totals for the summary
    let totalItemsCount = 0;
    let totalStacksCount = 0;

    // 1. Base Materials Breakdown
    text += "📦 RAW MATERIALS NEEDED:\n";
    text += "----------------------------------------------\n";
    
    const materials = Object.entries(breakdown)
        .filter(([id, qty]) => qty > 0)
        .sort((a, b) => b[1] - a[1]);
    
    for (const [itemId, quantity] of materials) {
        let itemData = null;
        for (const category of Object.values(items)) {
            itemData = category.find(item => item.id === itemId);
            if (itemData) break;
        }
        
        const itemName = itemData ? itemData.name : itemId;
        const stackSize = itemData ? itemData.stack : 64;
        
        // Calculations per item
        const itemStacks = Math.ceil(quantity / stackSize);
        const fullStacks = Math.floor(quantity / stackSize);
        const remainder = quantity % stackSize;
        const itemShulkers = Math.ceil(itemStacks / 27);

        // Add to project totals
        totalItemsCount += quantity;
        totalStacksCount += itemStacks;
        
        // Build the line (padEnd(25) ensures the columns align)
        let line = `${itemName} x${quantity.toLocaleString().padEnd(8)}`;
        line += ` -- Stacks: ${fullStacks} + ${remainder}`;
        if (itemShulkers > 0) {
            line += ` - [${itemShulkers} Shulker${itemShulkers > 1 ? 's' : ''}]`;
        }
        
        text += line + "\n";
    }
    
    text += "\n\n📦 Item List (Quick Copy):\n";
    text += "----------------------------------------------\n";
    for (const [itemId, quantity] of materials) {
        let itemData = null;
        for (const category of Object.values(items)) {
            itemData = category.find(item => item.id === itemId);
            if (itemData) break;
        }
        const itemName = itemData ? itemData.name : itemId;
        text += `${quantity.toLocaleString()} x ${itemName}\n`;
    }

    // 2. Intermediate Steps
    if (steps.length > 0) {
        text += "\n\n🔨 CRAFTING STEPS (Order: Top to Bottom):\n";
        text += "----------------------------------------------\n";
        
        const intermediate = steps.filter(s => 
            steps.some(other => other.inputs.some(inp => inp.id === s.output.id))
        ).sort((a, b) => b.depth - a.depth);

        intermediate.forEach((step, index) => {
            const inputs = step.inputs.map(i => `${i.amount}x ${i.name}`).join(' + ');
            text += `${index + 1}. ${inputs} → ${step.output.amount} ${step.output.name}\n`;
        });
    }

    // 3. THE PROJECT SUMMARY
    // Calculate final shulkers based on total inventory slots (stacks) used
    const finalShulkerTotal = Math.ceil(totalStacksCount / 27);

    text += "\n\n\n==============================================\n";
    text += "📊 PROJECT TOTALS SUMMARY\n";
    text += "==============================================\n";
    text += `TOTAL ITEMS:    ${totalItemsCount.toLocaleString()}\n`;
    text += `TOTAL STACKS:   ${totalStacksCount}\n`;
    text += `TOTAL SHULKERS: ${finalShulkerTotal} Boxes needed\n`;

    text += "\n\n\n==============================================\n";
    text += `Generated: ${new Date().toLocaleString()}\n`;
    text += "==============================================\n";

    // Download the file
    const blob = new Blob([text], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `base-materials-${Date.now()}.txt`;
    a.click();
    URL.revokeObjectURL(url);
    
    // Update button feedback
    const btn = document.getElementById('copy-list-btn');
    const originalText = btn.innerText;
    btn.innerText = "✅ Downloaded!";
    btn.style.background = "#77ff77";
    setTimeout(() => {
        btn.innerText = originalText;
        btn.style.background = "#55ff55";
    }, 2000);
}

function copyShoppingList(breakdown, steps) {
    let text = "=== MINECRAFT SHOPPING LIST ===\n\n";
    
    // 1. Base Materials
    text += "📦 RAW MATERIALS NEEDED:\n";
    const materials = Object.entries(breakdown)
        .filter(([id, qty]) => qty > 0)
        .sort((a, b) => b[1] - a[1]);
        
    materials.forEach(([id, qty]) => {
        const itemName = id.replace(/_/g, ' ').toUpperCase();
        text += `- ${qty}x ${itemName}\n`;
    });

    // 2. Intermediate Steps
    if (steps.length > 0) {
        text += "\n🔨 CRAFTING STEPS:\n";
        // Filter for intermediate only to keep it concise
        const intermediate = steps.filter(s => 
            steps.some(other => other.inputs.some(inp => inp.id === s.output.id))
        ).sort((a, b) => b.depth - a.depth);

        intermediate.forEach(step => {
            const inputs = step.inputs.map(i => `${i.amount} ${i.name}`).join(' + ');
            text += `- Craft ${inputs} → ${step.output.amount} ${step.output.name}\n`;
        });
    }

    text += "\npaste this into MC Book";

    // Copy to clipboard
    navigator.clipboard.writeText(text).then(() => {
        const btn = document.getElementById('copy-list-btn');
        const originalText = btn.innerText;
        btn.innerText = "✅ Copied!";
        btn.style.background = "#ffffff";
        setTimeout(() => {
            btn.innerText = originalText;
            btn.style.background = "#55ff55";
        }, 2000);
    });
}



document.addEventListener('DOMContentLoaded', initializeCalculator);

